/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto. Keeping your custom
 * Javascript in this file will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function() {
    // Add custom code below this line

    // Initialize all functionalities after DOM is loaded
    document.addEventListener('DOMContentLoaded', () => {
        const initDiscountCheckoutBridge = () => {
            const storageKey = 'aveaDiscountCode';

            const saveDiscountCode = (discountCode) => {
                if (!discountCode) return;

                try {
                    sessionStorage.setItem(storageKey, discountCode);
                    localStorage.setItem(storageKey, discountCode);
                } catch (error) {
                    // Storage can be unavailable; the Shopify /discount redirect remains the primary path.
                }
            };

            const getStoredDiscountCode = () => {
                try {
                    return sessionStorage.getItem(storageKey) || localStorage.getItem(storageKey) || '';
                } catch (error) {
                    return '';
                }
            };

            const getPathDiscountCode = () => {
                const pathMatch = window.location.pathname.match(/\/discount\/([^/?#]+)/i);
                return pathMatch ? decodeURIComponent(pathMatch[1]) : '';
            };

            const getCookieDiscountCode = () => {
                const cookieMatch = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
                return cookieMatch ? decodeURIComponent(cookieMatch[1]) : '';
            };

            const currentParams = new URLSearchParams(window.location.search);
            saveDiscountCode(currentParams.get('utm_discount') || getPathDiscountCode() || getCookieDiscountCode());

            const injectDiscountInput = () => {
                const discountCode = getStoredDiscountCode() || getCookieDiscountCode();
                if (!discountCode) return;

                document.querySelectorAll('form[action*="/cart"]').forEach((form) => {
                    if (!form.querySelector('[name="checkout"]')) return;

                    let discountInput = form.querySelector('input[name="discount"]');
                    if (!discountInput) {
                        discountInput = document.createElement('input');
                        discountInput.type = 'hidden';
                        discountInput.name = 'discount';
                        form.appendChild(discountInput);
                    }

                    discountInput.value = discountCode;
                });
            };

            injectDiscountInput();
            document.addEventListener('theme:cart:open', injectDiscountInput);
            document.addEventListener('cart:updated', injectDiscountInput);
            document.addEventListener('updateCartDrawer', injectDiscountInput);

            const cartDrawer = document.querySelector('[data-cart-drawer]');
            if (cartDrawer) {
                new MutationObserver(injectDiscountInput).observe(cartDrawer, {
                    childList: true,
                    subtree: true
                });
            }
        };

        initDiscountCheckoutBridge();

        const initGemPagesCartDrawerBridge = () => {
            const hasGemPagesProductButtons = document.querySelector('gp-product-button, .gp-product-button, .gp-button-atc');
            if (!hasGemPagesProductButtons) return;

            let openCartDrawerTimer = null;
            let lastOpenCartDrawerAt = 0;

            const refreshCartDrawer = () => {
                if (window.cart && typeof window.cart.getCart === 'function') {
                    window.cart.getCart();
                }

                document.dispatchEvent(new CustomEvent('updateCartDrawer'));
                document.dispatchEvent(new CustomEvent('cart:updated'));
            };

            const openCartDrawer = () => {
                if (window.cart && typeof window.cart.openCartDrawer === 'function') {
                    window.cart.openCartDrawer();
                    return;
                }

                const cartDrawer = document.querySelector('[data-cart-drawer]');
                if (!cartDrawer) return;

                const cartDrawerTemplate = cartDrawer.querySelector('[data-cart-drawer-template]');
                if (cartDrawerTemplate) {
                    cartDrawer.innerHTML = cartDrawerTemplate.innerHTML;
                }

                document.body.classList.add('js-drawer-open-cart');
                cartDrawer.classList.add('is-open');
                cartDrawer.classList.remove('cv-h');
                document.querySelectorAll('[data-cart-drawer-toggle]').forEach((toggle) => {
                    toggle.setAttribute('aria-expanded', 'true');
                });
            };

            const refreshAndOpenCartDrawer = () => {
                window.clearTimeout(openCartDrawerTimer);

                openCartDrawerTimer = window.setTimeout(() => {
                    const now = Date.now();
                    if (now - lastOpenCartDrawerAt < 1500) return;

                    lastOpenCartDrawerAt = now;
                    refreshCartDrawer();
                    window.setTimeout(openCartDrawer, 250);
                }, 700);
            };

            window.SLIDECART_UPDATE = refreshCartDrawer;
            window.SLIDECART_OPEN = refreshAndOpenCartDrawer;
            window.addEventListener('gp:add-to-cart-success', refreshAndOpenCartDrawer);
        };

        initGemPagesCartDrawerBridge();

        // One scroll owns the PDP navigation; never pull visitors back after arrival.
        const pdpScrollTargetId = 'scroll-to-pdp-div';
        const pdpScrollHash = `#${pdpScrollTargetId}`;
        const pdpNavTargetLabel = 'Details & purchase options';
        let pdpScrollFrame = null;
        let restorePdpScrollStyles = null;
        let pdpInitialScrollInterrupted = false;

        const getPdpScrollTarget = () => {
            return document.getElementById(pdpScrollTargetId) ||
                document.querySelector('#product-gempages-section-id .product-single__details, .product-single__details[data-collapsible-single]');
        };

        const getPdpScrollOffset = (targetTop) => {
            const fixedHeader = document.querySelector('[data-site-header][data-position="fixed"], .site-header--fixed');
            const headerHeight = fixedHeader ? fixedHeader.getBoundingClientRect().height : (window.stickyHeaderHeight || 0);
            const announcementBar = document.querySelector('[data-announcement-bar]');
            const announcementHeight = announcementBar ? announcementBar.getBoundingClientRect().height : 0;
            const productNav = document.querySelector('.product-details-nav');
            const navTrigger = document.getElementById('product-nav-trigger');
            const navTop = navTrigger ? navTrigger.getBoundingClientRect().top + window.pageYOffset : Infinity;
            // Account for navigation that will become fixed on the way to the product.
            const productNavHeight = productNav && targetTop > navTop ? productNav.getBoundingClientRect().height : 0;
            const mobileSectionNav = document.querySelector('.mobile-section-current');
            const mobileNav = document.querySelector('.mobile-section-nav');
            const mobileNavBottom = mobileNav ? mobileNav.getBoundingClientRect().bottom + window.pageYOffset : Infinity;
            const mobileSectionNavHeight = mobileSectionNav && targetTop > mobileNavBottom + 100
                ? mobileSectionNav.getBoundingClientRect().height : 0;

            return Math.ceil(headerHeight + announcementHeight + productNavHeight + mobileSectionNavHeight + 16);
        };

        const stopPdpScroll = () => {
            if (pdpScrollFrame !== null) {
                window.cancelAnimationFrame(pdpScrollFrame);
                pdpScrollFrame = null;
            }
            if (restorePdpScrollStyles) {
                restorePdpScrollStyles();
                restorePdpScrollStyles = null;
            }
            document.body.classList.remove('pdp-scroll-to-purchase-active');
        };

        const interruptPdpScroll = () => {
            pdpInitialScrollInterrupted = true;
            stopPdpScroll();
        };

        ['wheel', 'touchstart', 'pointerdown'].forEach((eventName) => {
            window.addEventListener(eventName, interruptPdpScroll, { passive: true });
        });
        window.addEventListener('keydown', (event) => {
            if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' ', 'Escape', 'Tab'].includes(event.key)) {
                interruptPdpScroll();
            }
        });
        window.addEventListener('pagehide', interruptPdpScroll);

        const getPdpNavTargetLinks = () => {
            return Array.from(document.querySelectorAll('.product-details-nav__link, .mobile-section-nav__link'))
                .filter((link) => link.dataset.target === pdpNavTargetLabel);
        };

        const setPdpNavActive = () => {
            const targetLinks = getPdpNavTargetLinks();

            if (!targetLinks.length) {
                return;
            }

            document.querySelectorAll('.product-details-nav__link, .mobile-section-nav__link').forEach((link) => {
                link.classList.remove('active');
            });

            targetLinks.forEach((link) => {
                link.classList.add('active');
            });

            const mobileCurrentName = document.querySelector('.mobile-section-current__name');

            if (mobileCurrentName) {
                mobileCurrentName.textContent = pdpNavTargetLabel;
            }
        };

        const scrollToPdpTarget = (smooth = true) => {
            stopPdpScroll();
            const target = getPdpScrollTarget();
            if (!target) return;

            const startY = window.pageYOffset;
            const targetTop = target.getBoundingClientRect().top + startY;
            const maxY = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
            // Freeze the destination so sticky header changes cannot reverse the animation.
            const targetY = Math.min(maxY, Math.max(0, targetTop - getPdpScrollOffset(targetTop)));
            const duration = smooth && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 800 : 0;
            const startTime = window.performance.now();
            const scrollElements = [document.documentElement, document.body];
            const previousStyles = scrollElements.map((element) => ({
                value: element.style.getPropertyValue('scroll-behavior'),
                priority: element.style.getPropertyPriority('scroll-behavior')
            }));

            // Prevent CSS smooth scrolling from starting a second animation on each frame.
            scrollElements.forEach((element) => element.style.setProperty('scroll-behavior', 'auto', 'important'));
            restorePdpScrollStyles = () => scrollElements.forEach((element, index) => {
                const previous = previousStyles[index];
                if (previous.value) {
                    element.style.setProperty('scroll-behavior', previous.value, previous.priority);
                } else {
                    element.style.removeProperty('scroll-behavior');
                }
            });

            document.body.classList.add('pdp-scroll-to-purchase-active');
            setPdpNavActive();

            const step = (now) => {
                const progress = duration ? Math.min((now - startTime) / duration, 1) : 1;
                const eased = 1 - Math.pow(1 - progress, 3);
                window.scrollTo({ top: startY + (targetY - startY) * eased, left: 0, behavior: 'auto' });

                if (progress < 1) {
                    pdpScrollFrame = window.requestAnimationFrame(step);
                } else {
                    stopPdpScroll();
                }
            };

            pdpScrollFrame = window.requestAnimationFrame(step);
        };

        // Align incoming hash links once loading finishes. User input cancels this too.
        if (window.location.hash === pdpScrollHash) {
            const alignInitialPdpHash = () => {
                if (!pdpInitialScrollInterrupted && window.location.hash === pdpScrollHash) {
                    scrollToPdpTarget(false);
                }
            };
            if (document.readyState === 'complete') {
                alignInitialPdpHash();
            } else {
                window.addEventListener('load', alignInitialPdpHash, { once: true });
            }
        }

        document.addEventListener('click', (event) => {
            if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            const link = event.target.closest(`a[href*="${pdpScrollHash}"]`);
            if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;

            const href = link.getAttribute('href');
            const url = new URL(href, window.location.href);
            const isSamePage = url.origin === window.location.origin &&
                url.pathname === window.location.pathname &&
                (href.charAt(0) === '#' || url.search === window.location.search);

            if (url.hash !== pdpScrollHash || !isSamePage || !getPdpScrollTarget()) return;

            event.preventDefault();
            event.stopImmediatePropagation();
            pdpInitialScrollInterrupted = true;

            if (window.location.hash !== pdpScrollHash) {
                history.pushState(null, '', pdpScrollHash);
            }

            scrollToPdpTarget();
        }, true);

        // Bundle Product Checkout Function
        const bundleAddToCartProduct = (currentThis, dynamicData) => {
            $.ajax({
                url: "/cart/add.js",
                type: "POST",
                data: {
                    items: dynamicData
                },
                dataType: "json",
                success: function(data) {
                    currentThis.removeClass('untouchable');
                    window.location.replace("/checkout");
                },
                error: function(jqXHR) {
                    currentThis.removeClass('untouchable');
                    if (jqXHR.status === 400) {
                        alert(jqXHR.responseJSON.message);
                    }
                    if (jqXHR.status === 422) {
                        alert(jqXHR.responseJSON.description);
                    }
                }
            });
        };

        // Initialize Bundle Product Checkout Button
        $('#lp_addToCart_btn, #lp_addToCart_btn_2').click(function() {
            const lpvariantId = $(this).attr('var-id');
            const quantity = 1;
            const updateItems = [];
            const currentThis = $(this);
            updateItems.push({
                "id": lpvariantId,
                "quantity": quantity
            });
            $.ajax({
                type: "POST",
                url: '/cart/clear.js',
                success: function() {
                    bundleAddToCartProduct(currentThis, updateItems);
                    currentThis.addClass('is-loading');
                },
                dataType: 'json'
            });
        });

        // Cart Progress Bar Fix for Subscription Products
        const handleCartAdded = () => {
            const sellingPlanSubscriptionElement = document.querySelector('.cart-drawer__items .cart__item__selling-plan-subscription');
            const cartMessageElement = document.querySelector('.cart-drawer__message');

            if (sellingPlanSubscriptionElement && cartMessageElement && !cartMessageElement.classList.contains('is-success')) {
                cartMessageElement.classList.add('is-success');
                const defaultMessage = document.querySelector('.cart__message__default');
                if (defaultMessage) {
                    defaultMessage.classList.add('is-hidden');
                }

                const progressElements = document.querySelectorAll('.cart__message__progress');
                progressElements.forEach(progressElement => {
                    progressElement.classList.add('is-hidden');
                    progressElement.setAttribute('value', '100');
                    progressElement.setAttribute('max', '100');
                    progressElement.style.setProperty('--progress-width', '100%');
                });
            }

            // CartDrawer Upgrade To Subscription Start
            const subscriptionButtons = document.querySelectorAll('.subscription-button');
            subscriptionButtons.forEach((button) => {
                if (button.getAttribute('data-click-added') === null) {
                    button.setAttribute('data-click-added', '');
                    button.addEventListener('click', () => {
                        const optionsContainer = button.nextElementSibling;
                        const selectElement = optionsContainer.querySelector('.subscription-select');
                        optionsContainer.style.display = 'block';
                        selectElement.style.display = 'block';
                        button.style.display = 'none';
                        button.classList.add('is-loading');
                        selectElement.showPicker();
                    });
                }
            });

        const subscriptionSelects = document.querySelectorAll('.subscription-select');
        subscriptionSelects.forEach((select) => {
        select.setAttribute('data-initial-value', select.value);

        select.addEventListener('change', function() {
          let initialValue = this.getAttribute('data-initial-value');
          if (this.value !== initialValue) {
            let cartItemID = this.closest('.upgrade-to-subscription').getAttribute('data-line-item-id');
            let selectedPlanID = this.value;
            let variantId = this.querySelector('option:checked').getAttribute('data-variant-id');
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: cartItemID, quantity: 0 }),
            })
            .then(response => response.json())
            .then(data => {
              fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  items: [{ id: variantId, quantity: 1, selling_plan: selectedPlanID }]
                }),
              })
              .then(response => response.json())
              .then(data => { location.reload(); })
              .catch(error => { console.error('Error adding item to cart:', error); });
            })
            .catch(error => { console.error('Error updating cart:', error); });

            this.style.display = 'none';
            this.closest('.upgrade-to-subscription').querySelector('.subscription-button').style.display = 'block';
            this.closest('.subscription-options-container').style.display = 'none';
            this.setAttribute('data-initial-value', this.value);
          }
        });
      });

            // CartDrawer Upgrade To Subscription End
        };

        document.addEventListener('theme:cart:added', handleCartAdded);
        document.addEventListener('theme:cart:open', handleCartAdded);

        // Read More Methods
        const header = document.querySelector('#SiteHeader');

        const lockScrollReadMore = () => {
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = `${scrollbarWidth}px`;
            if (header) {
                header.style.paddingRight = `${scrollbarWidth}px`;
            }
            document.body.setAttribute('data-scroll-lock-locked', 'true');
            document.documentElement.setAttribute('data-scroll-lock-locked', '');
        };

        const unlockScrollReadMore = () => {
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
            if (header) {
                header.style.paddingRight = '';
            }
            document.body.removeAttribute('data-scroll-lock-locked');
            document.documentElement.removeAttribute('data-scroll-lock-locked');
        };

        // Upsell Cart Methods
        const lockScrollUpsell = () => {
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = `${scrollbarWidth}px`;
            document.body.setAttribute('data-scroll-lock-locked', 'true');
            document.documentElement.setAttribute('data-scroll-lock-locked', '');
            document.body.classList.add('js-drawer-open');
        };

        const unlockScrollUpsell = () => {
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
            document.body.removeAttribute('data-scroll-lock-locked');
            document.documentElement.removeAttribute('data-scroll-lock-locked');
            document.body.classList.remove('js-drawer-open');
        };

        const getBundleProductData = (dataIndex, upsellCase, addToCartButton) => {
            let bundleProductItem = document.querySelector(`.bundle_product_options .bundle_prod_item[data-index="${dataIndex}"]`);
            
            if (!bundleProductItem) {
                bundleProductItem = document.querySelector('.bundle_product_options .bundle_prod_item[data-index="0"]');
            }
            
            if (!bundleProductItem) {
                const unitQuantityItem = document.querySelector(`.subscription-widget__selectors-unit-quantity .subscription-widget__selectors-label[data-index="${dataIndex}"]`);
                
                if (unitQuantityItem) {
                    const dataId = unitQuantityItem.getAttribute('data-variant-id');
                    const quantity = unitQuantityItem.getAttribute('data-quantity') || '1';
                    
                    if (upsellCase === 'upsell_enabled') {
                        storeOriginalFormInputsUpsell();
                        const upsellForm = document.querySelector('form[data-upsell-selector="upsell_additional_enabled"], form[data-upsell-selector="upsell_enabled"]');
                        updateFormInputs(upsellForm, dataId, '', parseInt(quantity));
                        addToCartButton.setAttribute('data-upsell-drawer-click', 'true');
                        addToCartButton.click();
                        restoreOriginalFormInputsUpsell();
                    } else {
                        addToCart(dataId, parseInt(quantity), null, addToCartButton);
                    }
                    return;
                }
            }
            
            if (bundleProductItem) {
                const dataId = bundleProductItem.getAttribute('data-id');
                const sellingPlanSelect = bundleProductItem.querySelector('.product-single__selling_plans');
                const sellingPlanId = sellingPlanSelect && sellingPlanSelect.selectedOptions.length > 0 ? sellingPlanSelect.selectedOptions[0].getAttribute('data-selling-plan-id') : null;
                
                if (upsellCase === 'upsell_enabled') {
                    storeOriginalFormInputsUpsell();
                    const upsellForm = document.querySelector('form[data-upsell-selector="upsell_additional_enabled"], form[data-upsell-selector="upsell_enabled"]');
                    updateFormInputs(upsellForm, dataId, sellingPlanId, 1);
                    addToCartButton.setAttribute('data-upsell-drawer-click', 'true');
                    addToCartButton.click();
                    restoreOriginalFormInputsUpsell();
                } else {
                    addToCart(dataId, 1, sellingPlanId, addToCartButton);
                }
            } else {
                console.log('WARNING: No product item found at all!');
            }
        };

        const addToCart = (variantId, quantity, sellingPlanId, addToCartButton) => {
            const item = {
                id: variantId,
                quantity: quantity
            };

            if (sellingPlanId) {
                item.selling_plan = sellingPlanId;
            }

            $.ajax({
                url: '/cart/add.js',
                type: 'POST',
                data: {
                    items: [item]
                },
                dataType: 'json',
                success: () => {
                    addToCartButton.setAttribute('data-upsell-drawer-click', 'true');
                    addToCartButton.click();
                },
                error: (jqXHR) => {
                    console.error('Error adding item to cart:', jqXHR.responseJSON);
                }
            });
        };

        const updateFormInputsUpsell = (id, sellingPlanId) => {
            const upsellForm = document.querySelector('form[data-upsell-selector="upsell_additional_enabled"], form[data-upsell-selector="upsell_enabled"]');
            const idInput = upsellForm.querySelector('input[name="id"][data-product-select]');
            if (idInput) {
                idInput.value = id;
            }
            const sellingPlanInput = upsellForm.querySelector('input[name="selling_plan"]');
            if (!sellingPlanId) {
                if (sellingPlanInput) {
                    sellingPlanInput.remove();
                }
            } else {
                if (sellingPlanInput) {
                    sellingPlanInput.value = sellingPlanId;
                } else {
                    const newSellingPlanInput = document.createElement('input');
                    newSellingPlanInput.type = 'hidden';
                    newSellingPlanInput.name = 'selling_plan';
                    newSellingPlanInput.value = sellingPlanId;
                    upsellForm.appendChild(newSellingPlanInput);
                }
            }
        };

        const storeOriginalFormInputsUpsell = () => {
            const upsellForm = document.querySelector('form[data-upsell-selector="upsell_additional_enabled"], form[data-upsell-selector="upsell_enabled"]');
            const idInput = upsellForm.querySelector('input[name="id"][data-product-select]');
            const sellingPlanInput = upsellForm.querySelector('input[name="selling_plan"]');
            const quantityInput = upsellForm.querySelector('input[name="quantity"]');
        
            upsellForm.setAttribute('data-original-id', idInput ? idInput.value : '');
            upsellForm.setAttribute('data-original-selling-plan', sellingPlanInput ? sellingPlanInput.value : '');
            upsellForm.setAttribute('data-original-quantity', quantityInput ? quantityInput.value : '1');
        };
        
        const restoreOriginalFormInputsUpsell = () => {
            const upsellForm = document.querySelector('form[data-upsell-selector="upsell_additional_enabled"], form[data-upsell-selector="upsell_enabled"]');
            const originalId = upsellForm.getAttribute('data-original-id');
            const originalSellingPlan = upsellForm.getAttribute('data-original-selling-plan');
            const originalQuantity = upsellForm.getAttribute('data-original-quantity');
        
            const idInput = upsellForm.querySelector('input[name="id"][data-product-select]');
            if (idInput) {
                idInput.value = originalId;
            }
        
            const quantityInput = upsellForm.querySelector('input[name="quantity"]');
            if (quantityInput) {
                quantityInput.value = originalQuantity || '1';
            }
        
            const sellingPlanInput = upsellForm.querySelector('input[name="selling_plan"]');
            if (!originalSellingPlan) {
                if (sellingPlanInput) {
                    sellingPlanInput.remove();
                }
            } else {
                if (sellingPlanInput) {
                    sellingPlanInput.value = originalSellingPlan;
                } else {
                    const newSellingPlanInput = document.createElement('input');
                    newSellingPlanInput.type = 'hidden';
                    newSellingPlanInput.name = 'selling_plan';
                    newSellingPlanInput.value = originalSellingPlan;
                    upsellForm.appendChild(newSellingPlanInput);
                }
            }
        };

        // Subscription Selector Methods
        const toggleClass = (element, className, condition) => {
            condition ? element.classList.add(className) : element.classList.remove(className);
        };

        const updateAttribute = (element, attributeName, value) => {
            element.setAttribute(attributeName, value);
        };

        const updateFormInputs = (form, id, sellingPlanId, quantity = 1) => {
            const idInput = form.querySelector('input[name="id"][data-product-select]');
            if (idInput) {
                idInput.value = id;
            }
        
            let quantityInput = form.querySelector('input[name="quantity"]');
            if (quantityInput) {
                quantityInput.value = quantity;
            } else if (quantity > 1) {
                quantityInput = document.createElement('input');
                quantityInput.type = 'hidden';
                quantityInput.name = 'quantity';
                quantityInput.value = quantity;
                form.appendChild(quantityInput);
            }
        
            const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
            if (!sellingPlanId) {
                if (sellingPlanInput) {
                    sellingPlanInput.remove();
                }
            } else {
                if (sellingPlanInput) {
                    sellingPlanInput.value = sellingPlanId;
                } else {
                    const newSellingPlanInput = document.createElement('input');
                    newSellingPlanInput.type = 'hidden';
                    newSellingPlanInput.name = 'selling_plan';
                    newSellingPlanInput.value = sellingPlanId;
                    form.appendChild(newSellingPlanInput);
                }
            }
        };

        const toggleSaveUpToMessage = (element, showSaveUpElement) => {
            const saveUpToElement = element.closest('form').querySelector('.subscription-widget__item-save-up-to');
            const savingPriceElement = element.closest('form').querySelector('.subscription-widget__subscription-saving-price');

            if (showSaveUpElement) {
                saveUpToElement.classList.remove('subscription-widget__hidden');
                savingPriceElement.classList.add('subscription-widget__hidden');
              
            } else {              
                saveUpToElement.classList.add('subscription-widget__hidden');
                savingPriceElement.classList.remove('subscription-widget__hidden');
            }
        };

        // =====================================================================
        // Version C is a duplicate of Version B's flat layout, just shown by
        // default instead of behind an explicit test flag. Anywhere the code
        // used to branch on "is it version B" or hardcode the
        // `.subscription-widget__version-b` selector, it needs to treat
        // version C identically.
        // =====================================================================
        const getActiveFlatVersionClass = (widgetContainer) => {
            if (!widgetContainer) return null;
            if (widgetContainer.classList.contains('test-version-b')) return 'subscription-widget__version-b';
            if (widgetContainer.classList.contains('test-version-c')) return 'subscription-widget__version-c';
            return null;
        };

        const updatePrice = (element, price) => {
            const widgetContainer = element.closest('.subscription-widget');
            const isVersionB = !!getActiveFlatVersionClass(widgetContainer);

            let priceSpan;
            if (isVersionB) {
                const itemWrap = element.closest('.subscription-widget__item-wrap');
                priceSpan = itemWrap ? itemWrap.querySelector('.subscription-widget__item-price') : null;
            } else {
                priceSpan = element.querySelector('.subscription-widget__item-price');
            }
            
            const addToCartPriceElement = element.closest('form').querySelector('.product__submit__buttons button span[data-product-price]');

            if (priceSpan && addToCartPriceElement) {
                priceSpan.textContent = price;
                addToCartPriceElement.textContent = price;
            } else if (priceSpan) {
                priceSpan.textContent = price;
            }
        };

        const getUnitServingPrice = (totalPriceString, quantity, basePriceString) => {
            const regex = /([^\d.,]*\s?[^\d]*)?([\d.,]+)([^\d]*)/;
            const match = totalPriceString.match(regex);
            const baseMatch = basePriceString.match(regex);
        
            if (match && baseMatch) {
                let currencySymbol = match[1];
                let totalPrice = match[2];
                let basePrice = baseMatch[2];
                const currencySymbolAfter = match[3];
        
                if (currencySymbolAfter) {
                    currencySymbol += currencySymbolAfter;
                }
        
                const lastCommaIndex = totalPrice.lastIndexOf(',');
                const lastPeriodIndex = totalPrice.lastIndexOf('.');
        
                let thousandsSeparator = ',';
                let decimalSeparator = '.';
                if (lastCommaIndex > lastPeriodIndex) {
                    thousandsSeparator = '.';
                    decimalSeparator = ',';
                }
        
                totalPrice = totalPrice.split(thousandsSeparator).join('');
                totalPrice = totalPrice.replace(decimalSeparator, '.');
                totalPrice = parseFloat(totalPrice);
        
                basePrice = basePrice.split(thousandsSeparator).join('');
                basePrice = basePrice.replace(decimalSeparator, '.');
                basePrice = parseFloat(basePrice);
        
                const perUnitPrice = totalPrice / quantity;
                const servingPrice = perUnitPrice / 30;
        
                return `${currencySymbol}${servingPrice.toFixed(2)}`;
            } else {
                console.error('Invalid price string');
                return totalPriceString;
            }
        };

        // =====================================================================
        // Helper to get the selected option VALUES from all radio selectors.
        // Returns e.g. ["Forte (500mg)", "Raspberry Mint"]
        // =====================================================================
        const getSelectedOptionValues = () => {
            const productSelectors = document.querySelector('.product__selectors');
            if (!productSelectors) return [];

            const optionWrappers = Array.from(
                productSelectors.querySelectorAll('.selector-wrapper[data-option-position]')
            ).sort((a, b) => {
                return parseInt(a.getAttribute('data-option-position')) - parseInt(b.getAttribute('data-option-position'));
            });

            return optionWrappers.map(wrapper => {
                const checkedRadio = wrapper.querySelector('input[type="radio"]:checked');
                return checkedRadio ? checkedRadio.value : '';
            });
        };

        // =====================================================================
        // Helper to get the selected variant index based on ALL option selectors.
        // Uses Shopify's standard variant ordering (last option changes fastest).
        //
        // IMPORTANT: This scans the MAIN page's .product__selectors only.
        // If called from inside a photoswipe/lightbox context where those radios
        // don't exist, it falls back to 0.
        // =====================================================================
        const getSelectedVariantIndex = () => {
            const productSelectors = document.querySelector('.product__selectors');
            if (!productSelectors) return 0;

            const optionWrappers = Array.from(
                productSelectors.querySelectorAll('.selector-wrapper[data-option-position]')
            ).sort((a, b) => {
                return parseInt(a.getAttribute('data-option-position')) - parseInt(b.getAttribute('data-option-position'));
            });

            if (optionWrappers.length === 0) return 0;

            const optionSelections = optionWrappers.map(wrapper => {
                const radios = wrapper.querySelectorAll('input[type="radio"]');
                let selectedIdx = 0;
                radios.forEach((radio, idx) => {
                    if (radio.checked) {
                        selectedIdx = idx;
                    }
                });
                return {
                    selectedIndex: selectedIdx,
                    totalOptions: radios.length
                };
            });

            let variantIndex = 0;
            for (let i = 0; i < optionSelections.length; i++) {
                let multiplier = 1;
                for (let j = i + 1; j < optionSelections.length; j++) {
                    multiplier *= optionSelections[j].totalOptions;
                }
                variantIndex += optionSelections[i].selectedIndex * multiplier;
            }

            return variantIndex;
        };

        // =====================================================================
        // Get variant data from data-variants-all using the correct multi-option index.
        // =====================================================================
            const getVariantDataFromLabel = (label) => {
                const dataAttributes = JSON.parse(label.getAttribute('data-variants-all'));
                const selectedOptions = getSelectedOptionValues();
                const selectedIndex = getSelectedVariantIndex();

                // Try to match by option values first (reliable across different products)
                if (selectedOptions.length > 0 && dataAttributes.length > 0 && dataAttributes[0].options) {
                    const match = dataAttributes.find(v => {
                        if (!v.options || v.options.length !== selectedOptions.length) return false;
                        return v.options.every((opt, i) => opt === selectedOptions[i]);
                    });
                    if (match) return match;
                }

                // Fallback: positional index (for backward compatibility)
                const idx = Math.min(selectedIndex, dataAttributes.length - 1);
                return dataAttributes[idx];
            };

        // =====================================================================
        // Format cents to money string using the currency code from the label.
        // Detects European vs US format from existing data-price attributes.
        // =====================================================================
        const formatCentsToMoney = (cents, currencyCode) => {
            const testLabel = document.querySelector('.subscription-widget__selectors-label[data-price]');
            const testPrice = testLabel ? testLabel.getAttribute('data-price') : '';
            const usesCommaDecimal = testPrice && /\d\.\d{3},/.test(testPrice);
            
            const amount = cents / 100;
            
            if (usesCommaDecimal) {
                const parts = amount.toFixed(2).split('.');
                const intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
                return `${currencyCode}${intPart},${parts[1]}`;
            } else {
                const parts = amount.toFixed(2).split('.');
                const intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                return `${currencyCode}${intPart}.${parts[1]}`;
            }
        };

        const updateServingPrice = (element) => {
            const priceString = element.getAttribute('data-price');
            const planName = element.getAttribute('data-index');
            const isUnitQuantity = element.closest('.subscription-widget__selectors-unit-quantity');
            const widgetContainer = element.closest('.subscription-widget');
            const activeFlatVersionClass = getActiveFlatVersionClass(widgetContainer);
            const isVersionB = !!activeFlatVersionClass;

            const variantData = getVariantDataFromLabel(element);
            let effectivePriceString = priceString;
            
            if (variantData && variantData.price_cents !== undefined) {
                const currencyCode = element.getAttribute('data-currency-code') || '';
                effectivePriceString = formatCentsToMoney(variantData.price_cents, currencyCode);
            }

            let newPrice;
            if (isUnitQuantity) {
                const quantity = parseInt(element.getAttribute('data-quantity') || '1');
                
                if (variantData && variantData.price_cents !== undefined) {
                    const currencyCode = element.getAttribute('data-currency-code') || '';
                    const discountPercent = parseInt(element.getAttribute('data-discount-percent') || '0');
                    const perUnitCents = variantData.price_cents;
                    const totalCents = Math.round(perUnitCents * quantity * (1 - discountPercent / 100));
                    effectivePriceString = formatCentsToMoney(totalCents, currencyCode);
                }
                
                const basePrice = widgetContainer.querySelector('.subscription-widget__item-onetime .subscription-widget__item-price').textContent;
                newPrice = getUnitServingPrice(effectivePriceString, quantity, basePrice);
            } else {
                newPrice = getServingPrice(effectivePriceString, planName);
            }
            
            const priceClass = (!isUnitQuantity && planName > 0 && planName < 4) ? 'subscribe' : 'one-time';
        
            let servingPriceElement;
            if (isVersionB && isUnitQuantity) {
                const oneTimeItem = widgetContainer.querySelector(`.${activeFlatVersionClass} .subscription-widget__item-onetime`).closest('.subscription-widget__item');
                servingPriceElement = oneTimeItem ? oneTimeItem.querySelector('.subscription-widget__serving-price.one-time') : null;
            } else {
                servingPriceElement = widgetContainer.querySelector(`.subscription-widget__serving-price.${priceClass}`);
            }
            
            if (servingPriceElement) {
                servingPriceElement.textContent = newPrice;
            } else {
                console.error('Could not find .subscription-widget__serving-price element', {
                    priceClass,
                    isVersionB,
                    isUnitQuantity
                });
            }
        };

        const updateFormDataIndex = (form, dataIndex) => {
            form.setAttribute('data-selected-item-index', dataIndex);
        };

        const getServingPrice = (priceString, planName) => {
            const regex = /([^\d.,]*\s?[^\d]*)?([\d.,]+)([^\d]*)/;
            const match = priceString.match(regex);

            if (match) {
                let currencySymbol = match[1];
                let price = match[2];
                const currencySymbolAfter = match[3];

                if (currencySymbolAfter) {
                    currencySymbol += currencySymbolAfter;
                }

                const lastCommaIndex = price.lastIndexOf(',');
                const lastPeriodIndex = price.lastIndexOf('.');

                let thousandsSeparator = ',';
                let decimalSeparator = '.';
                if (lastCommaIndex > lastPeriodIndex) {
                    thousandsSeparator = '.';
                    decimalSeparator = ',';
                }

                price = price.split(thousandsSeparator).join('');
                price = price.replace(decimalSeparator, '.');
                price = parseFloat(price);

                switch (planName) {
                    case '0':
                    case '3':
                        price /= 30;
                        break;
                    case '2':
                    case '4':
                        price /= 90;
                        break;
                    case '5':
                        price /= 180;
                        break;
                    case '1':
                    case '6':
                        price /= 365;
                        break;
                    default:
                        console.error('Invalid plan name');
                        return priceString;
                }

                return `${currencySymbol}${price.toFixed(2)}`;
            } else {
                console.error('Invalid price string');
                return priceString;
            }
        };

        // =====================================================================
        // Update prices for unit quantity labels based on current variant.
        // Called when variant options change to recalculate all unit prices.
        // =====================================================================
        const updateUnitPricesForVariant = (widgetContainer) => {
            const unitLabels = widgetContainer.querySelectorAll('.subscription-widget__selectors-unit-quantity .subscription-widget__selectors-label');
            if (unitLabels.length === 0) return;

            unitLabels.forEach(label => {
                const variantData = getVariantDataFromLabel(label);
                if (variantData && variantData.price_cents !== undefined) {
                    const currencyCode = label.getAttribute('data-currency-code') || '';
                    const quantity = parseInt(label.getAttribute('data-quantity') || '1');
                    const discountPercent = parseInt(label.getAttribute('data-discount-percent') || '0');
                    const perUnitCents = variantData.price_cents;
                    const totalCents = Math.round(perUnitCents * quantity * (1 - discountPercent / 100));
                    const compareTotalCents = variantData.compare_at_cents 
                        ? variantData.compare_at_cents * quantity 
                        : perUnitCents * quantity;
                    
                    label.setAttribute('data-price', formatCentsToMoney(totalCents, currencyCode));
                    label.setAttribute('data-compare-price', formatCentsToMoney(compareTotalCents, currencyCode));
                    label.setAttribute('data-variant-id', variantData.variant_id);
                }
            });

            // Re-trigger the currently selected unit label to update display
            const selectedUnitLabel = widgetContainer.querySelector('.subscription-widget__selectors-unit-quantity .subscription-widget__selectors-radio-subscriptions[data-checked]');
            if (selectedUnitLabel) {
                const label = selectedUnitLabel.closest('label');
                if (label) {
                    onSubscriptionLabelClick(label);
                }
            }
        };

        // =====================================================================
        // Update subscription prices for version B based on current variant.
        // =====================================================================
        const updateSubscriptionPricesForVariant = (widgetContainer) => {
            const activeFlatVersionClass = getActiveFlatVersionClass(widgetContainer);
            const isVersionB = !!activeFlatVersionClass;

            if (isVersionB) {
                const subscriptionItems = widgetContainer.querySelectorAll(`.${activeFlatVersionClass} .subscription-widget__item-wrap--subscription .subscription-widget__item`);
                subscriptionItems.forEach(item => {
                    const variantsAllStr = item.getAttribute('data-variants-all');
                    if (!variantsAllStr) return;
                    
                    const variantsAll = JSON.parse(variantsAllStr);
                    const selectedIndex = getSelectedVariantIndex();
                    const idx = Math.min(selectedIndex, variantsAll.length - 1);
                    const variantData = variantsAll[idx];
                    
                    if (variantData) {
                        item.setAttribute('data-variant-id', variantData.variant_id);
                        
                        if (variantData.price_cents !== undefined) {
                            const currencyCode = widgetContainer.querySelector('.subscription-widget__selectors-label[data-currency-code]');
                            const code = currencyCode ? currencyCode.getAttribute('data-currency-code') : '€';
                            const newPrice = formatCentsToMoney(variantData.price_cents, code);
                            item.setAttribute('data-price', newPrice);
                            
                            const priceSpan = item.querySelector('.subscription-widget__item-price');
                            if (priceSpan) {
                                priceSpan.textContent = newPrice;
                            }
                            
                            const subscriptionIndex = item.getAttribute('data-subscription-index');
                            const servingPriceEl = item.querySelector(`.subscription-widget__serving-price[data-subscription-index="${subscriptionIndex}"]`);
                            if (servingPriceEl) {
                                servingPriceEl.textContent = getServingPrice(newPrice, subscriptionIndex);
                            }
                        }
                    }
                });
            }
            
            // Update subscription labels in version A
            const subscriptionLabels = widgetContainer.querySelectorAll('.subscription-widget__version-a .subscription-widget__selectors-label-subscriptions--0, .subscription-widget__version-a .subscription-widget__selectors-label-subscriptions--1, .subscription-widget__version-a .subscription-widget__selectors-label-subscriptions--2');
            subscriptionLabels.forEach(label => {
                const variantData = getVariantDataFromLabel(label);
                if (variantData && variantData.price_cents !== undefined) {
                    const currencyCode = label.getAttribute('data-currency-code') || '';
                    const newPrice = formatCentsToMoney(variantData.price_cents, currencyCode);
                    label.setAttribute('data-price', newPrice);
                    label.setAttribute('data-variant-id', variantData.variant_id);
                    
                    if (variantData.compare_at_cents) {
                        label.setAttribute('data-compare-price', formatCentsToMoney(variantData.compare_at_cents, currencyCode));
                    }
                }
            });
        };

        // =====================================================================
        // Version C: keep the "buy once" link's variant + displayed price in
        // sync with the currently selected product options (e.g. NMN Strength).
        // =====================================================================
        const updateBuyOnceLinkForVariant = (widgetContainer) => {
            const buyOnceLink = widgetContainer.querySelector('.subscription-widget__buy-once-link');
            if (!buyOnceLink || !buyOnceLink.getAttribute('data-variants-all')) return;

            const variantData = getVariantDataFromLabel(buyOnceLink);
            if (!variantData) return;

            buyOnceLink.setAttribute('data-variant-id', variantData.variant_id);

            if (variantData.price_cents !== undefined) {
                const currencyCode = buyOnceLink.getAttribute('data-currency-code') || '';
                const newPrice = formatCentsToMoney(variantData.price_cents, currencyCode);
                const priceSpan = buyOnceLink.querySelector('.subscription-widget__buy-once-price');
                if (priceSpan) {
                    priceSpan.textContent = newPrice;
                }
            }
        };

        // VERSION A HANDLERS
        const onSubscriptionItemClick = (item, subscriptionItems, container) => {
            subscriptionItems.forEach((i) => {
                toggleClass(i, 'selected', i === item);
                updateAttribute(i.querySelector('button'), 'aria-expanded', i === item ? 'true' : 'false');
            });

            const form = item.closest('form[action*="/cart/add"]');
            if (item.querySelector('.subscription-widget__item-onetime')) {
                toggleSaveUpToMessage(item, true);
                if (item.querySelector('.subscription-widget__selectors')) {
                    const selectedItem = item.querySelector('.subscription-widget__selectors-radio-subscriptions[data-checked]');
                    selectedItem ? selectedItem.closest('label').click() : clickOneJarLabel(container);
                } else {
                    if (form) {
                        // =====================================================
                        // FIX: For one-time without sub-labels, get the correct
                        // variant ID based on currently selected product options
                        // instead of using the static label attribute.
                        // =====================================================
                        const variantIndex = getSelectedVariantIndex();
                        const noscriptSelect = form.querySelector('noscript select[name="id"]');
                        let variantId = item.querySelector('label').getAttribute('variant-id');
                        if (noscriptSelect) {
                            const options = noscriptSelect.querySelectorAll('option');
                            if (options[variantIndex]) {
                                variantId = options[variantIndex].value;
                                item.querySelector('label').setAttribute('variant-id', variantId);
                            }
                        }
                        updateFormInputs(form, variantId, '');
                        updatePrice(item, item.querySelector('.subscription-widget__item-price').textContent);
                        updateFormDataIndex(form, "0");
                    }
                }
            } else if (item.querySelector('.subscription-widget__item-subscribe')) {
                toggleSaveUpToMessage(item, false);
                const selectedItem = item.querySelector('.subscription-widget__selectors-radio-subscriptions[data-checked]');
                selectedItem ? selectedItem.closest('label').click() : clickOneMonthLabel(container);
            }
        };

            const onSubscriptionLabelClick = (label) => {
            const widgetContainer = label.closest('.subscription-widget');
            if (widgetContainer?.getAttribute('data-main-product-available') === 'false') return;
            const radioGroupWrapper = label.parentElement;
            radioGroupWrapper.querySelectorAll('.subscription-widget__selectors-radio-subscriptions').forEach((radio) => {
                radio.removeAttribute('data-checked');
            });

            const radioSubscriptions = label.querySelector('.subscription-widget__selectors-radio-subscriptions');
            radioSubscriptions.setAttribute('data-checked', '');

            const form = label.closest('form[action*="/cart/add"]');
            const itemWrap = label.closest('.subscription-widget__item-wrap');
            if (form && itemWrap) {
                // Get variant data based on ALL selected product options
                const variantData = getVariantDataFromLabel(label);
                const dataVariantId = variantData.variant_id;
                const dataSellingPlanId = variantData.selling_plan_id || '';
                const dataQuantity = label.getAttribute('data-quantity');
                const quantity = dataQuantity !== null ? parseInt(dataQuantity) : 1;
                
                // Update the label's data-variant-id to match current selection
                label.setAttribute('data-variant-id', dataVariantId);
                
                // =====================================================
                // FIX: For unit quantity labels, also update the hidden
                // label[variant-id] on the one-time item so the form
                // always has the correct variant for the current options.
                // =====================================================
                const isUnitQuantity = label.closest('.subscription-widget__selectors-unit-quantity');
                if (isUnitQuantity) {
                    const oneTimeItem = itemWrap.closest('.subscription-widget__item');
                    if (oneTimeItem) {
                        const hiddenLabel = oneTimeItem.querySelector('label[variant-id]');
                        if (hiddenLabel) {
                            hiddenLabel.setAttribute('variant-id', dataVariantId);
                        }
                    }
                }
                
                updateFormInputs(form, dataVariantId, dataSellingPlanId, quantity);
                
                // If we have price_cents, update the price on the label for accurate display
                if (variantData.price_cents !== undefined) {
                    const currencyCode = label.getAttribute('data-currency-code') || '';
                    
                    if (isUnitQuantity) {
                        const discountPercent = parseInt(label.getAttribute('data-discount-percent') || '0');
                        const totalCents = Math.round(variantData.price_cents * quantity * (1 - discountPercent / 100));
                        const newPrice = formatCentsToMoney(totalCents, currencyCode);
                        label.setAttribute('data-price', newPrice);
                        updatePrice(itemWrap, newPrice);
                    } else {
                        const newPrice = formatCentsToMoney(variantData.price_cents, currencyCode);
                        label.setAttribute('data-price', newPrice);
                        updatePrice(itemWrap, newPrice);
                    }
                } else {
                    updatePrice(itemWrap, label.getAttribute('data-price'));
                }
                
                updateServingPrice(label);
                updateFormDataIndex(form, label.getAttribute('data-index'));

                const frequencyText = itemWrap.querySelector('.subscription-widget__selectors-info-items-fequency');
                if (frequencyText) {
                    frequencyText.innerHTML = label.getAttribute('data-plan-desc');
                }
            }
        };

        // VERSION B HANDLERS
        const onSubscriptionItemClickVersionB = (item, allItems, container) => {
            const widgetContainer = container.closest('.subscription-widget') || container;
            const isVersionB = !!getActiveFlatVersionClass(widgetContainer);

            if (!isVersionB) return;

            allItems.forEach((i) => {
                i.classList.remove('selected');
                const button = i.querySelector('button');
                if (button) {
                    button.setAttribute('aria-expanded', 'false');
                }
            });

            item.classList.add('selected');
            const clickedButton = item.querySelector('button');
            if (clickedButton) {
                clickedButton.setAttribute('aria-expanded', 'true');
            }

            const form = container.closest('form[action*="/cart/add"]') || widgetContainer.closest('form[action*="/cart/add"]');
            if (!form) return;

            const subscriptionType = clickedButton.getAttribute('data-subscription-type');
            
            if (subscriptionType === 'onetime') {
                const selectedUnitLabel = item.querySelector('.subscription-widget__selectors-radio-subscriptions[data-checked]');
                if (selectedUnitLabel) {
                    const label = selectedUnitLabel.closest('label');
                    if (label) {
                        onSubscriptionLabelClick(label);
                    }
                } else {
                    clickOneJarLabel(container);
                }
            } else if (subscriptionType === 'subscription') {
                const subscriptionIndex = clickedButton.getAttribute('data-index');
                const variantsAll = item.getAttribute('data-variants-all');
                const price = item.getAttribute('data-price');
                
                if (variantsAll) {
                    const dataAttributes = JSON.parse(variantsAll);
                    const selectedIndex = getSelectedVariantIndex();
                    const idx = Math.min(selectedIndex, dataAttributes.length - 1);
                    const variantData = dataAttributes[idx];
                    
                    const dataVariantId = variantData.variant_id;
                    const dataSellingPlanId = variantData.selling_plan_id || '';
                    
                    updateFormInputs(form, dataVariantId, dataSellingPlanId, 1);
                    updateFormDataIndex(form, subscriptionIndex);
                    
                    let displayPrice = price;
                    if (variantData.price_cents !== undefined) {
                        const currencyCodeLabel = widgetContainer.querySelector('.subscription-widget__selectors-label[data-currency-code]');
                        const code = currencyCodeLabel ? currencyCodeLabel.getAttribute('data-currency-code') : '€';
                        displayPrice = formatCentsToMoney(variantData.price_cents, code);
                        item.setAttribute('data-price', displayPrice);
                    }
                    
                    const priceSpan = item.querySelector('.subscription-widget__item-price');
                    const addToCartPriceElement = form.querySelector('.product__submit__buttons button span[data-product-price]');
                    if (priceSpan) {
                        priceSpan.textContent = displayPrice;
                    }
                    if (addToCartPriceElement) {
                        addToCartPriceElement.textContent = displayPrice;
                    }

                    const servingPriceElement = item.querySelector(`.subscription-widget__serving-price[data-subscription-index="${subscriptionIndex}"]`);
                    if (servingPriceElement) {
                        const newServingPrice = getServingPrice(displayPrice, subscriptionIndex);
                        servingPriceElement.textContent = newServingPrice;
                    }
                }
            }
        };

        const addClickListeners = (container, selector, handler) => {
            const elements = container.querySelectorAll(selector);
            elements.forEach((element) => {
                if (!element.hasAttribute('data-click-listener-added')) {
                    element.addEventListener('click', handler);
                    element.setAttribute('data-click-listener-added', 'true');
                }
            });
        };

        // =====================================================================
        // Version C: "Buy once for {price}" link replaces the whole one-time-
        // purchase card. One click adds 1 unit straight to the cart (no radio
        // selection, no separate add-to-cart button) and opens the cart drawer
        // the same way every other AJAX add-to-cart flow in this file does.
        // =====================================================================
        const onBuyOnceLinkClick = (event) => {
            event.preventDefault();

            const link = event.currentTarget;
            if (link.classList.contains('is-loading')) return;

            const widgetContainer = link.closest('.subscription-widget');
            if (widgetContainer?.getAttribute('data-main-product-available') === 'false') return;

            // Resolve the variant from the currently selected product options
            // (NMN Strength etc.) rather than trusting the static attribute,
            // in case the radio-change listener hasn't fired yet for some reason.
            let variantId = link.getAttribute('data-variant-id');
            if (link.getAttribute('data-variants-all')) {
                const variantData = getVariantDataFromLabel(link);
                if (variantData) {
                    variantId = variantData.variant_id;
                }
            }
            const quantity = parseInt(link.getAttribute('data-quantity') || '1', 10);

            link.classList.add('is-loading');

            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
            })
                .then((response) => {
                    if (!response.ok) {
                        return response.json().then((errData) => {
                            throw new Error(errData.description || 'Failed to add item to cart');
                        });
                    }
                    return response.json();
                })
                .then(() => {
                    if (window.cart && typeof window.cart.getCart === 'function') {
                        window.cart.getCart();
                    }
                    document.dispatchEvent(new CustomEvent('theme:cart:added'));
                })
                .catch((error) => {
                    console.error('Error adding item to cart:', error);
                })
                .finally(() => {
                    link.classList.remove('is-loading');
                });
        };

        const initSubscriptionWidget = (widgetId) => {
            const widgetContainers = document.querySelectorAll(`.subscription-widget[data-widget-id="${widgetId}"]`);
            widgetContainers.forEach((widgetContainer) => {
                if (!widgetContainer.getAttribute('data-widget-initiated')) {
                    const activeFlatVersionClass = getActiveFlatVersionClass(widgetContainer);
                    const isVersionB = !!activeFlatVersionClass;

                    if (activeFlatVersionClass === 'subscription-widget__version-c') {
                        document.body.classList.add('has-subscription-widget-version-c');
                    }

                    addClickListeners(widgetContainer, '.subscription-widget__buy-once-link', onBuyOnceLinkClick);
                    updateBuyOnceLinkForVariant(widgetContainer);

                    if (isVersionB) {
                        const allItems = widgetContainer.querySelectorAll(`.${activeFlatVersionClass} .subscription-widget__item`);

                        addClickListeners(widgetContainer, `.${activeFlatVersionClass} .subscription-widget__item button`, (event) => {
                            const button = event.currentTarget;
                            const item = button.closest('.subscription-widget__item');
                            onSubscriptionItemClickVersionB(item, allItems, widgetContainer);
                        });

                        addClickListeners(widgetContainer, `.${activeFlatVersionClass} .subscription-widget__selectors-label`, (event) => {
                            event.stopPropagation();
                            onSubscriptionLabelClick(event.currentTarget);
                        });

                        setTimeout(() => {
                            const allSubscriptionButtons = widgetContainer.querySelectorAll(
                                `.${activeFlatVersionClass} .subscription-widget__item button[data-subscription-type="subscription"]`
                            );
                            allSubscriptionButtons.forEach(btn => btn.click());
                            if (allSubscriptionButtons.length > 0) {
                                // Version C renders the 90-day (Quarterly) plan first, so it's
                                // already index 0; Version B keeps its original ordering.
                                const defaultIndex = activeFlatVersionClass === 'subscription-widget__version-c' ? 0 : 1;
                                allSubscriptionButtons[defaultIndex].click();
                            }
                        }, 100);

                    } else {
                        addClickListeners(widgetContainer, '.subscription-widget__version-a .subscription-widget__item', (event) => {
                            const item = event.currentTarget;
                            const subscriptionItems = widgetContainer.querySelectorAll('.subscription-widget__version-a .subscription-widget__item');
                            onSubscriptionItemClick(item, subscriptionItems, widgetContainer);
                        });

                        addClickListeners(widgetContainer, '.subscription-widget__version-a .subscription-widget__selectors-label', (event) => {
                            event.stopPropagation();
                            onSubscriptionLabelClick(event.currentTarget);
                        });

                        clickSubscriptionPlan(widgetContainer);
                        clickOneJarLabel(widgetContainer);
                        clickOneMonthLabel(widgetContainer);

                        setupRadioChangeListener(widgetContainer);
                    }

                    setupAllRadioChangeListeners(widgetContainer);

                    widgetContainer.setAttribute('data-widget-initiated', 'true');
                }
            });
        };

        // =====================================================================
        // Setup radio change listeners for ALL option selectors.
        // Ensures variant changes from any option trigger price/variant updates.
        //
        // KEY FIX: After updating the selected item, also update the non-selected
        // one-time item's prices and variant IDs so they're ready when clicked.
        // =====================================================================
        const setupAllRadioChangeListeners = (widgetContainer) => {
            const productSelectors = document.querySelector('.product__selectors');
            if (!productSelectors) return;

            const allOptionWrappers = productSelectors.querySelectorAll('.selector-wrapper[data-option-position]');
            
            allOptionWrappers.forEach(wrapper => {
                const radioButtons = wrapper.querySelectorAll('input[type="radio"]');
                radioButtons.forEach(radio => {
                    const listenerKey = `data-widget-${widgetContainer.getAttribute('data-widget-id')}-listener`;
                    if (radio.getAttribute(listenerKey)) return;
                    radio.setAttribute(listenerKey, 'true');

                    radio.addEventListener('change', () => {
                        const activeFlatVersionClass = getActiveFlatVersionClass(widgetContainer);
                        const isVersionB = !!activeFlatVersionClass;

                        // First, update all data attributes on labels for new variant
                        updateUnitPricesForVariant(widgetContainer);
                        updateSubscriptionPricesForVariant(widgetContainer);
                        updateBuyOnceLinkForVariant(widgetContainer);

                        if (isVersionB) {
                            const selectedItem = widgetContainer.querySelector(`.${activeFlatVersionClass} .subscription-widget__item.selected`);
                            if (selectedItem) {
                                const button = selectedItem.querySelector('button');
                                if (button) {
                                    button.click();
                                }
                            }
                        } else {
                            // Version A: update the currently selected item
                            const openedRadioGroup = widgetContainer.querySelector('.subscription-widget__item.selected');
                            if (openedRadioGroup) {
                                const checkedElement = openedRadioGroup.querySelector('.subscription-widget__selectors-radio-subscriptions[data-checked]');
                                if (checkedElement) {
                                    checkedElement.closest('label').click();
                                } else {
                                    // One-time purchase without unit sub-labels
                                    const form = widgetContainer.closest('form[action*="/cart/add"]');
                                    if (form) {
                                        const variantIndex = getSelectedVariantIndex();
                                        const oneTimeLabel = openedRadioGroup.querySelector('label[variant-id]');
                                        if (oneTimeLabel) {
                                            const noscriptSelect = form.querySelector('noscript select[name="id"]');
                                            if (noscriptSelect) {
                                                const options = noscriptSelect.querySelectorAll('option');
                                                if (options[variantIndex]) {
                                                    const newVariantId = options[variantIndex].value;
                                                    oneTimeLabel.setAttribute('variant-id', newVariantId);
                                                    updateFormInputs(form, newVariantId, '');
                                                }
                                            }
                                        }
                                    }
                                }
                            }

                            // =====================================================
                            // FIX: Also update all NON-selected one-time items so
                            // their hidden variant-id and prices stay in sync.
                            // =====================================================
                            const allItems = widgetContainer.querySelectorAll('.subscription-widget__version-a .subscription-widget__item');
                            const form = widgetContainer.closest('form[action*="/cart/add"]');
                            allItems.forEach(item => {
                                const oneTimeButton = item.querySelector('.subscription-widget__item-onetime');
                                if (!oneTimeButton || item.classList.contains('selected')) return;
                                if (!form) return;

                                // Update the hidden label variant-id
                                const variantIndex = getSelectedVariantIndex();
                                const hiddenLabel = item.querySelector('label[variant-id]');
                                if (hiddenLabel) {
                                    const noscriptSelect = form.querySelector('noscript select[name="id"]');
                                    if (noscriptSelect) {
                                        const options = noscriptSelect.querySelectorAll('option');
                                        if (options[variantIndex]) {
                                            hiddenLabel.setAttribute('variant-id', options[variantIndex].value);
                                        }
                                    }
                                }

                                // Update the one-time base price display
                                const unitQuantitySection = item.querySelector('.subscription-widget__selectors-unit-quantity');
                                if (unitQuantitySection) {
                                    const oneUnitLabel = unitQuantitySection.querySelector('.subscription-widget__selectors-label[data-quantity="1"]');
                                    if (oneUnitLabel) {
                                        const variantData = getVariantDataFromLabel(oneUnitLabel);
                                        if (variantData && variantData.price_cents !== undefined) {
                                            const currencyCode = oneUnitLabel.getAttribute('data-currency-code') || '';
                                            const oneUnitPrice = formatCentsToMoney(variantData.price_cents, currencyCode);
                                            
                                            const oneTimePriceSpan = oneTimeButton.querySelector('.subscription-widget__item-price');
                                            if (oneTimePriceSpan) {
                                                oneTimePriceSpan.textContent = oneUnitPrice;
                                            }
                                            
                                            const servingPriceEl = oneTimeButton.querySelector('.subscription-widget__serving-price.one-time');
                                            if (servingPriceEl) {
                                                const servingCents = variantData.price_cents / 30;
                                                servingPriceEl.textContent = formatCentsToMoney(Math.round(servingCents), currencyCode);
                                            }
                                        }
                                    }
                                }
                            });
                        }
                    });
                });
            });
        };

        const setupRadioChangeListener = (widgetContainer) => {
            const optionWrapper = window.document.querySelector('.product__selectors [data-option-position="1"]');
            if (optionWrapper) {
                const radioButtons = optionWrapper.querySelectorAll('input[type="radio"]');

                radioButtons.forEach((radio) => {
                    radio.addEventListener('change', function() {
                        const activeFlatVersionClass = getActiveFlatVersionClass(widgetContainer);
                        const isVersionB = !!activeFlatVersionClass;

                        if (isVersionB) {
                            const selectedItem = widgetContainer.querySelector(`.${activeFlatVersionClass} .subscription-widget__item.selected`);
                            if (selectedItem) {
                                const button = selectedItem.querySelector('button');
                                if (button) {
                                    button.click();
                                }
                            }
                        } else {
                            const openedRadioGroup = document.querySelector('.subscription-widget__item.selected');
                            if (openedRadioGroup) {
                                const checkedElement = openedRadioGroup.querySelector('.subscription-widget__selectors-radio-subscriptions[data-checked]');

                                if (checkedElement) {
                                    checkedElement.closest('label').click();
                                } else {
                                    console.log('No element with data-checked attribute found.');
                                }
                            } else {
                                console.log('No opened subscription-widget__selectors-radiogroup found.');
                            }
                        }
                    });
                });
            } else {
                console.log('No element found with data-option-position="1".');
            }
        };

        const clickSubscriptionPlan = (widgetContainer) => {
            const subscribeButton = widgetContainer.querySelector('.subscription-widget__version-a .subscription-widget__item-subscribe');
            if (subscribeButton) {
                subscribeButton.click();
            }
            
            setTimeout(() => {
                const unitQuantitySelector = widgetContainer.querySelector('.subscription-widget__selectors-unit-quantity');
                if (!unitQuantitySelector) {
                    clickOneMonthLabel(widgetContainer);
                }
            }, 100);
        };

        const clickOneMonthLabel = (widgetContainer) => {
            const unitQuantitySelector = widgetContainer.querySelector('.subscription-widget__selectors-unit-quantity');
            if (unitQuantitySelector) {
                const monthlyLabel = widgetContainer.querySelector('.subscription-widget__version-a .subscription-widget__selectors-label-subscriptions--2');
                if (monthlyLabel) {
                    monthlyLabel.click();
                }
            } else {
                const oneMonthLabel = widgetContainer.querySelector('.subscription-widget__version-a .subscription-widget__selectors-label[data-index="3"]');
                if (oneMonthLabel) {
                    oneMonthLabel.click();
                }
            }
        };

        const clickOneJarLabel = (widgetContainer) => {
            const unitQuantitySelector = widgetContainer.querySelector('.subscription-widget__selectors-unit-quantity');
            if (unitQuantitySelector) {
                const oneUnitLabel = widgetContainer.querySelector('.subscription-widget__selectors-label[data-quantity="1"]');
                if (oneUnitLabel) {
                    oneUnitLabel.click();
                }
            } else {
                const oneJarLabel = widgetContainer.querySelector('.subscription-widget__selectors-label[data-index="0"]');
                if (oneJarLabel) {
                    oneJarLabel.click();
                }
            }
        };

        // Free Gift / Double Progress Bar initialization
        let isFirstLoad = true;
        if (window.themeSettings && (window.themeSettings.freeGiftData || window.themeSettings.freeGiftEnabled)) {
        const data = window.themeSettings.freeGiftData || {};

        const freeShippingLimit = data.freeShippingLimit || 0;
        const currencyEnabled = data.currencyEnabled;
        const currencyRate =
            window.Shopify && window.Shopify.currency && window.Shopify.currency.rate
            ? parseFloat(window.Shopify.currency.rate)
            : 1;
        const moneyFormat = currencyEnabled
            ? theme.moneyWithCurrencyFormat
            : theme.moneyFormat;
        const freeGiftMessage = data.freeGiftMessage || "";
        const shippingGiftMessage = data.shippingGiftMessage || "";
        const shippingMessage = data.freeShippingMessage || "";
        const freeGiftLimit = data.freeGiftLimit || window.themeSettings.freeGiftLimit || 0;
        const freeGiftLimitCurrency = freeGiftLimit * 100;
        const freeGiftProductHandle = data.freeGiftProductHandle || window.themeSettings.giftProductHandle;
        const freeGiftQuantity = 1;
        const freeGiftVariantId = data.freeGiftVariantId || window.themeSettings.thresholdGiftVariantId || window.themeSettings.giftVariantId;

        // Support multi-trigger array: [{ handle, variantId, productId }]
        const freeGiftOnProductTriggers = (
            data.freeGiftOnProductTriggers && data.freeGiftOnProductTriggers.length > 0
            ? data.freeGiftOnProductTriggers
            : window.themeSettings.triggerProducts && window.themeSettings.triggerProducts.length > 0
                ? window.themeSettings.triggerProducts
                : window.themeSettings.triggerProduct
                    ? [{ handle: window.themeSettings.triggerProduct, variantId: window.themeSettings.triggerProduct, productId: window.themeSettings.triggerProductId }]
                    : []
        );
        const freeGiftOnProductVariantId = data.freeGiftOnProductVariantId || window.themeSettings.triggerGiftVariantId || window.themeSettings.giftVariantId;

        // Gift product availability — set by Liquid in theme.liquid
        const giftProductAvailable = window.themeSettings.giftProductAvailable !== false;

        // UTM gate: if configured, only users with matching UTM param get the trigger gift
        const freeGiftUtmSetting = (data.freeGiftUtmValue || window.themeSettings.freeGiftUtmValue || '').trim();
        let freeGiftUtmKey = 'utm_atc';
        let freeGiftUtmValue = freeGiftUtmSetting;
        if (freeGiftUtmSetting.includes('=')) {
            const parts = freeGiftUtmSetting.split('=');
            freeGiftUtmKey = parts[0].trim();
            freeGiftUtmValue = parts[1].trim();
        }
        const urlParams = new URLSearchParams(window.location.search);
        const utmValueFromUrl = urlParams.get(freeGiftUtmKey);
        if (utmValueFromUrl) {
            sessionStorage.setItem(freeGiftUtmKey, utmValueFromUrl);
        }

        const isUtmGateEnabled = freeGiftUtmSetting.length > 0;
        const storedUtmValue = sessionStorage.getItem(freeGiftUtmKey) || '';
        // Decide ONCE at page load — this never changes during the session
        const passesUtmGate = !isUtmGateEnabled || storedUtmValue === freeGiftUtmValue;

        let cartTotalPrice = window.themeSettings.cartTotalPrice || 0;
        let isUpdatingCart = false;
        let hasShownOosAlert = false;

        const updateProgressBarsWithCart = (cart) => {
            const decodeHTMLEntities = (text) => {
            const tempElement = document.createElement('textarea');
            tempElement.innerHTML = text;
            return tempElement.value;
            };

            const cartTotalPriceCents = cart.total_price;
            const limitShippingCents = freeShippingLimit * 100 * currencyRate;
            const limitGiftCents = freeGiftLimit * 100 * currencyRate;

            const hasSubscription = cart.items.some((item) => item.selling_plan_allocation);

            let shippingPercent = 0;
            let giftPercent = 0;

            if (hasSubscription) {
            shippingPercent = 100;
            } else {
            shippingPercent = (cartTotalPriceCents / limitShippingCents) * 100;
            shippingPercent = Math.min(shippingPercent, 100);
            }

            if (cartTotalPriceCents >= limitGiftCents) {
            giftPercent = 100;
            } else {
            giftPercent =
                ((cartTotalPriceCents - limitShippingCents) / (limitGiftCents - limitShippingCents)) * 100;
            giftPercent = Math.max(0, Math.min(giftPercent, 100));
            }

            const prevShippingPercent = parseFloat(document.querySelector('.shipping-bar')?.dataset.prevPercent || 0);
            const prevGiftPercent = parseFloat(document.querySelector('.gift-bar')?.dataset.prevPercent || 0);

            updateProgressBarsAndIcons(shippingPercent, giftPercent, prevShippingPercent, prevGiftPercent);

            const messageEl = document.querySelector('.cart-drawer__message-new');
            if (!messageEl) return;

            const defaultMsg = messageEl.querySelector('.cart__message__default-new');
            const successMsg = messageEl.querySelector('.cart__message__success-new');

            if (successMsg && defaultMsg && giftPercent >= 100) {
            successMsg.textContent = decodeHTMLEntities(shippingGiftMessage);
            successMsg.classList.remove('is-hidden');
            defaultMsg.classList.add('is-hidden');
            } else if (defaultMsg && successMsg && shippingPercent >= 100) {
            const leftToSpend = limitGiftCents - cartTotalPriceCents;
            const leftToSpendFormatted = themeVendor.themeCurrency.formatMoney(leftToSpend, moneyFormat).replace('.00','').replace(',00','');
            defaultMsg.textContent = decodeHTMLEntities(freeGiftMessage.replace('||amount||', leftToSpendFormatted));
            defaultMsg.classList.remove('is-hidden');
            successMsg.classList.add('is-hidden');
            } else if (defaultMsg && successMsg) {
            const leftToSpend = limitShippingCents - cartTotalPriceCents;
            const leftToSpendFormatted = themeVendor.themeCurrency.formatMoney(leftToSpend, moneyFormat).replace('.00','').replace(',00','');
            defaultMsg.textContent = decodeHTMLEntities(shippingMessage.replace('||amount||', leftToSpendFormatted));
            defaultMsg.classList.remove('is-hidden');
            successMsg.classList.add('is-hidden');
            }

            messageEl.classList.toggle('shipping-achieved', shippingPercent >= 100);
            messageEl.classList.toggle('gift-achieved', giftPercent >= 100);

            const shippingBar = document.querySelector('.shipping-bar');
            if (shippingBar) shippingBar.dataset.prevPercent = shippingPercent;
            const giftBar = document.querySelector('.gift-bar');
            if (giftBar) giftBar.dataset.prevPercent = giftPercent;
        };

        const updateProgressBarsAndIcons = (shippingPercent, giftPercent, prevShippingPercent, prevGiftPercent) => {
            const shippingBar = document.querySelector('.shipping-bar');
            const giftBar = document.querySelector('.gift-bar');
            const shippingSVG = document.querySelector('#shippingSvgUniqueId');
            const giftSVG = document.querySelector('#freeGiftSvgUniqueId');

            if (!shippingSVG || !giftSVG) return;

            const giftBgPath = giftSVG.querySelector('#bgPath');
            const giftFgPath = giftSVG.querySelector('#fgPath');
            const giftShapePath = giftSVG.querySelector('#shapePath');
            const shippingBgPath = shippingSVG.querySelector('#bgPathIcon');
            const shippingFgPath = shippingSVG.querySelector('#fgPathIcon');
            const shippingShapePath = shippingSVG.querySelector('#shapePathIcon');
            const shippingSmallShapePath = shippingSVG.querySelector('#smallShapeIcon');

            const accentColor = '#7bacba';
            const defaultColor = '#e5e5e5';

            if (shippingPercent > prevShippingPercent || giftPercent > prevGiftPercent) {
            if (shippingBar) {
                shippingBar.style.width = shippingPercent + '%';
                setTimeout(() => {
                if (shippingPercent >= 100) {
                    if (shippingBgPath) shippingBgPath.style.fill = defaultColor;
                    if (shippingFgPath) shippingFgPath.style.fill = accentColor;
                    if (shippingShapePath) shippingShapePath.style.fill = defaultColor;
                    if (shippingSmallShapePath) shippingSmallShapePath.style.fill = defaultColor;
                } else {
                    if (shippingBgPath) shippingBgPath.style.fill = accentColor;
                    if (shippingFgPath) shippingFgPath.style.fill = defaultColor;
                    if (shippingShapePath) shippingShapePath.style.fill = accentColor;
                    if (shippingSmallShapePath) shippingSmallShapePath.style.fill = accentColor;
                }
                }, 300);
            }
            setTimeout(() => {
                if (giftBar) {
                giftBar.style.width = giftPercent + '%';
                setTimeout(() => {
                    if (giftPercent >= 100) {
                    if (giftBgPath) giftBgPath.style.fill = defaultColor;
                    if (giftFgPath) giftFgPath.style.fill = accentColor;
                    if (giftShapePath) giftShapePath.style.fill = defaultColor;
                    } else {
                    if (giftBgPath) giftBgPath.style.fill = accentColor;
                    if (giftFgPath) giftFgPath.style.fill = defaultColor;
                    if (giftShapePath) giftShapePath.style.fill = accentColor;
                    }
                }, 300);
                }
            }, 600);
            } else {
            if (giftBar) {
                if (giftPercent >= 100) {
                if (giftBgPath) giftBgPath.style.fill = defaultColor;
                if (giftFgPath) giftFgPath.style.fill = accentColor;
                if (giftShapePath) giftShapePath.style.fill = defaultColor;
                } else {
                if (giftBgPath) giftBgPath.style.fill = accentColor;
                if (giftFgPath) giftFgPath.style.fill = defaultColor;
                if (giftShapePath) giftShapePath.style.fill = accentColor;
                }
                setTimeout(() => { giftBar.style.width = giftPercent + '%'; }, 300);
            }
            setTimeout(() => {
                if (shippingBar) {
                if (shippingPercent >= 100) {
                    if (shippingBgPath) shippingBgPath.style.fill = defaultColor;
                    if (shippingFgPath) shippingFgPath.style.fill = accentColor;
                    if (shippingShapePath) shippingShapePath.style.fill = defaultColor;
                    if (shippingSmallShapePath) shippingSmallShapePath.style.fill = defaultColor;
                } else {
                    if (shippingBgPath) shippingBgPath.style.fill = accentColor;
                    if (shippingFgPath) shippingFgPath.style.fill = defaultColor;
                    if (shippingShapePath) shippingShapePath.style.fill = accentColor;
                    if (shippingSmallShapePath) shippingSmallShapePath.style.fill = accentColor;
                }
                setTimeout(() => { shippingBar.style.width = shippingPercent + '%'; }, 300);
                }
            }, 600);
            }
        };

        const updateCartData = () => {
            fetch('/cart.js')
            .then((response) => response.json())
            .then((cart) => {
                cartTotalPrice = cart.total_price;
                const progressBarElement = document.querySelector('.cart-drawer__message-new.cart__message-new');
                const hasHolidayBox = cart.items.some((item) => item.product_title === "Gift Box");
                if (cartTotalPrice <= 0 || hasHolidayBox) {
                if (progressBarElement) progressBarElement.classList.add('is-hidden');
                } else {
                if (progressBarElement) progressBarElement.classList.remove('is-hidden');
                }

                updateProgressBarsWithCart(cart);

                if (!isUpdatingCart) {
                checkGiftEligibilityWithCart(cart);
                }
            })
            .catch((error) => { console.error('Error fetching cart data:', error); });
        };

        const checkGiftEligibilityWithCart = (cart) => {
            const adjustedFreeGiftLimitCurrency = freeGiftLimitCurrency * currencyRate;
            const cartTotalPrice = cart.total_price;
            const hasHolidayBox = cart.items.some((item) => item.product_title === "Gift Box");

            let shouldHaveThresholdGift = false;
            if (freeGiftVariantId && freeGiftLimit > 0 && !hasHolidayBox) {
            if (cartTotalPrice >= adjustedFreeGiftLimitCurrency) {
                shouldHaveThresholdGift = true;
            }
            }

            let shouldHaveTriggerGift = false;
            let triggerGiftOutOfStock = false;
            if (passesUtmGate && freeGiftOnProductTriggers.length > 0) {
            const isTriggerInCart = cart.items.some(item => {
                return freeGiftOnProductTriggers.some(trigger => {
                return String(item.id) === String(trigger.variantId) ||
                        String(item.product_id) === String(trigger.variantId) ||
                        String(item.product_id) === String(trigger.productId) ||
                        item.handle === String(trigger.handle);
                });
            });

            if (isTriggerInCart) {
                if (freeGiftOnProductVariantId && giftProductAvailable) {
                shouldHaveTriggerGift = true;
                } else {
                triggerGiftOutOfStock = true;
                }
            }
            }

            const thresholdGiftItem = cart.items.find(item =>
            String(item.id) === String(freeGiftVariantId) &&
            item.properties && item.properties._gift_type === 'threshold'
            ) || cart.items.find(item =>
            String(item.id) === String(freeGiftVariantId) &&
            item.properties && item.properties._free_gift === 'true' && !item.properties._gift_type
            );

            const triggerGiftItem = cart.items.find(item =>
            String(item.id) === String(freeGiftOnProductVariantId) &&
            item.properties && item.properties._gift_type === 'trigger'
            ) || cart.items.find(item =>
            String(item.id) === String(freeGiftOnProductVariantId) &&
            item.properties && item.properties._free_gift === 'true' && !item.properties._gift_type && item.id !== freeGiftVariantId
            );

            if (shouldHaveThresholdGift && !thresholdGiftItem) {
            addGift(freeGiftVariantId, 'threshold');
            } else if (!shouldHaveThresholdGift && thresholdGiftItem) {
            removeGift(thresholdGiftItem.key);
            } else if (triggerGiftOutOfStock && !hasShownOosAlert) {
            hasShownOosAlert = true;
            alert('Sorry, the free gift is currently out of stock.');
            } else if (shouldHaveTriggerGift && !triggerGiftItem) {
            addGift(freeGiftOnProductVariantId, 'trigger');
            } else if (!shouldHaveTriggerGift && triggerGiftItem) {
            removeGift(triggerGiftItem.key);
            }
        };

        const addGift = (variantId, type) => {
            if (isUpdatingCart) return;
            isUpdatingCart = true;

            fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [{
                id: variantId,
                quantity: 1,
                properties: { '_free_gift': 'true', '_gift_type': type }
                }]
            })
            })
            .then(response => {
            if (!response.ok) {
                return response.json().then(errData => {
                if (response.status === 422) {
                    alert('Sorry, the free gift is currently out of stock.');
                }
                throw new Error(errData.description || 'Failed to add gift');
                });
            }
            return response.json();
            })
            .then(data => {
            if (window.cart && typeof window.cart.getCart === 'function') {
                window.cart.getCart();
            }
            updateCartData();
            setTimeout(() => { isUpdatingCart = false; }, 2000);
            })
            .catch(error => {
            console.error('Error adding gift:', error);
            isUpdatingCart = false;
            });
        };

        const removeGift = (key) => {
            if (isUpdatingCart) return;
            isUpdatingCart = true;

            fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
            })
            .then(response => response.json())
            .then(data => {
            if (window.cart && typeof window.cart.getCart === 'function') {
                window.cart.getCart();
            }
            updateCartData();
            setTimeout(() => { isUpdatingCart = false; }, 2000);
            })
            .catch(error => {
            console.error('Error removing gift:', error);
            isUpdatingCart = false;
            });
        };

        // Set up event listeners for updating cart data
        const eventsToUpdateCartData = [
            'theme:cart:open',
            'theme:cart:added',
            'theme:cart:change',
            'cart:updated',
        ];
        eventsToUpdateCartData.forEach((event) => {
            document.addEventListener(event, () => { updateCartData(); });
        });

        // Initial check on page load
        updateCartData();
        }
        
          // Add item on every x items initialization
        if (window.themeSettings && window.themeSettings.addPerX && window.themeSettings.addPerX.enabled) {
            const perXData = window.themeSettings.addPerX;
            const perXTriggers = perXData.triggerVariantIds || [];
            const perXTriggerQty = perXData.triggerQuantity || 2;
            const perXGiftVariantId = perXData.giftVariantId;

            // UTM gate (same pattern as trigger gift)
            const perXUtmSetting = (perXData.utmValue || '').trim();
            let perXUtmKey = 'utm_atc';
            let perXUtmValue = perXUtmSetting;
            if (perXUtmSetting.includes('=')) {
                const [k, v] = perXUtmSetting.split('=');
                perXUtmKey = k.trim();
                perXUtmValue = v.trim();
            }
            const perXUrlParams = new URLSearchParams(window.location.search);
            const perXUtmFromUrl = perXUrlParams.get(perXUtmKey);
            if (perXUtmFromUrl) {
                sessionStorage.setItem(perXUtmKey, perXUtmFromUrl);
            }
            const perXIsUtmGated = perXUtmSetting.length > 0;
            const perXStoredUtm = sessionStorage.getItem(perXUtmKey) || '';
            const perXPassesUtm = !perXIsUtmGated || perXStoredUtm === perXUtmValue;

            let isUpdatingPerX = false;

            const checkPerXEligibility = (cart) => {
                if (!perXGiftVariantId || perXTriggers.length === 0) return;

                // Count total quantity of trigger variants in cart, excluding per_x gift lines
                let totalTriggerQty = 0;
                cart.items.forEach(item => {
                    if (item.properties && item.properties._gift_type === 'per_x') return;
                    const isTrigger = perXTriggers.some(tid => String(item.id) === String(tid));
                    if (isTrigger) totalTriggerQty += item.quantity;
                });

                const expectedQty = perXPassesUtm ? Math.floor(totalTriggerQty / perXTriggerQty) : 0;

                // Find existing per_x gift line in cart
                const existingGift = cart.items.find(item =>
                    String(item.id) === String(perXGiftVariantId) &&
                    item.properties && item.properties._gift_type === 'per_x'
                );
                const currentQty = existingGift ? existingGift.quantity : 0;

                if (expectedQty === currentQty) return;

                if (expectedQty > 0) {
                    if (existingGift) {
                        updatePerXGift(existingGift.key, expectedQty);
                    } else {
                        addPerXGift(perXGiftVariantId, expectedQty);
                    }
                } else {
                    if (existingGift) removePerXGift(existingGift.key);
                }
            };

            const addPerXGift = (variantId, qty) => {
                if (isUpdatingPerX) return;
                isUpdatingPerX = true;
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        items: [{ id: variantId, quantity: qty, properties: { '_free_gift': 'true', '_gift_type': 'per_x' } }]
                    })
                })
                .then(response => {
                    if (!response.ok) return response.json().then(e => { throw new Error(e.description || 'Failed to add per-x gift'); });
                    return response.json();
                })
                .then(() => {
                    if (window.cart && typeof window.cart.getCart === 'function') window.cart.getCart();
                    setTimeout(() => { isUpdatingPerX = false; fetchAndCheckPerX(); }, 2000);
                })
                .catch(err => { console.error('Error adding per-x gift:', err); isUpdatingPerX = false; });
            };

            const updatePerXGift = (key, qty) => {
                if (isUpdatingPerX) return;
                isUpdatingPerX = true;
                fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: key, quantity: qty })
                })
                .then(response => response.json())
                .then(() => {
                    if (window.cart && typeof window.cart.getCart === 'function') window.cart.getCart();
                    setTimeout(() => { isUpdatingPerX = false; fetchAndCheckPerX(); }, 2000);
                })
                .catch(err => { console.error('Error updating per-x gift:', err); isUpdatingPerX = false; });
            };

            const removePerXGift = (key) => {
                if (isUpdatingPerX) return;
                isUpdatingPerX = true;
                fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: key, quantity: 0 })
                })
                .then(response => response.json())
                .then(() => {
                    if (window.cart && typeof window.cart.getCart === 'function') window.cart.getCart();
                    setTimeout(() => { isUpdatingPerX = false; fetchAndCheckPerX(); }, 2000);
                })
                .catch(err => { console.error('Error removing per-x gift:', err); isUpdatingPerX = false; });
            };

            const fetchAndCheckPerX = () => {
                if (isUpdatingPerX) return;
                fetch('/cart.js')
                    .then(response => response.json())
                    .then(cart => checkPerXEligibility(cart))
                    .catch(err => console.error('Error fetching cart for per-x check:', err));
            };

            ['theme:cart:open', 'theme:cart:added', 'theme:cart:change', 'cart:updated'].forEach(event => {
                document.addEventListener(event, () => { fetchAndCheckPerX(); });
            });

            fetchAndCheckPerX();
        }
        // Global check for cart changes via AJAX override
        const originalFetch = window.fetch;
        window.fetch = function() {
        return originalFetch.apply(this, arguments).then(response => {
            if (
            response.url.includes('/cart/add') ||
            response.url.includes('/cart/change') ||
            response.url.includes('/cart/update') ||
            response.url.includes('/cart/clear')
            ) {
            // Small delay to let Shopify process the cart
            setTimeout(() => {
                document.dispatchEvent(new CustomEvent('cart:updated'));
            }, 500);
            }
            return response;
        });
        };
        // Read More initialization
        const drawerToggles = document.querySelectorAll('[data-drawer-toggle-custom]');
        const drawerOverlays = document.querySelectorAll('.drawer__overlay');

        drawerToggles.forEach((toggle) => {
            toggle.addEventListener('click', () => {
                const drawerId = toggle.getAttribute('aria-controls');
                const drawer = document.getElementById(drawerId);

                if (drawer) {
                    const isHidden = drawer.getAttribute('aria-hidden') === 'true';
                    drawer.setAttribute('aria-hidden', !isHidden);

                    if (isHidden) {
                        drawer.classList.add('is-open');
                        document.body.classList.add('js-drawer-open');
                        lockScrollReadMore();
                    } else {
                        drawer.classList.remove('is-open');
                        document.body.classList.remove('js-drawer-open');
                        unlockScrollReadMore();
                    }
                }
            });
        });

        drawerOverlays.forEach((overlay) => {
            overlay.addEventListener('click', () => {
                const drawer = document.querySelector('.product__popup.drawer.is-open[data-drawer-custom]');
                if (drawer) {
                    drawer.setAttribute('aria-hidden', 'true');
                    drawer.classList.remove('is-open');
                    document.body.classList.remove('js-drawer-open');
                    unlockScrollReadMore();
                }
            });
        });

        // Upsell Cart initialization
        const upsellProduct = document.querySelector('.cdk-upsell-product.upsell-product');
        const upsellForm = document.querySelector('form[data-upsell-selector="upsell_additional_enabled"], form[data-upsell-selector="upsell_enabled"]');

        if (upsellProduct && upsellForm) {
            const addToCartButton = upsellForm.querySelector('.MAINBUTTON[data-add-to-cart]');
            addToCartButton.setAttribute('data-upsell-drawer-click', 'false');
            addToCartButton.addEventListener('click', (event) => {
                const skipUpsell = addToCartButton.getAttribute('data-skip-upsell') === 'true';
                if (!skipUpsell && upsellForm && addToCartButton.getAttribute('data-upsell-drawer-click') === 'false') {
                    event.preventDefault();
                    event.stopPropagation();
                    if (upsellProduct) {
                        upsellProduct.classList.add('is-open');
                    }
                    lockScrollUpsell();
                } else {
                    addToCartButton.setAttribute('data-upsell-drawer-click', 'false');
                }
            });

            const upsellCase = upsellForm.getAttribute('data-upsell-selector');
            const upsellCloseButton = document.querySelector('.cart-drawer__close.upsell-close');
            const upsellButton = document.querySelector('.addUpsell_product');
            const normalButton = document.querySelector('.addNormal_product');

            if (upsellCloseButton && upsellForm) {
                upsellCloseButton.addEventListener('click', (event) => {
                    event.preventDefault();
                    addToCartButton.setAttribute('data-upsell-drawer-click', true);
                    addToCartButton.click();
                    upsellProduct.classList.remove('is-open');
                    unlockScrollUpsell();
                });
            }

           drawerOverlays.forEach((overlay) => {
                overlay.addEventListener('click', () => {
                    if (upsellProduct.classList.contains('is-open')) {
                        addToCartButton.setAttribute('data-upsell-drawer-click', true);
                        addToCartButton.click();
                        upsellProduct.classList.remove('is-open');
                        unlockScrollUpsell();
                    }
                });
            });

            if (upsellButton && upsellForm) {
                upsellButton.addEventListener('click', (event) => {
                    event.preventDefault();
                    const index = upsellForm.getAttribute('data-selected-item-index');
                    getBundleProductData(index, upsellCase, addToCartButton);
                    upsellProduct.classList.remove('is-open');
                    unlockScrollUpsell();
                });
            }

            if (normalButton && upsellForm) {
                normalButton.addEventListener('click', (event) => {
                    event.preventDefault();
                    addToCartButton.setAttribute('data-upsell-drawer-click', true);
                    addToCartButton.click();
                    upsellProduct.classList.remove('is-open');
                    unlockScrollUpsell();
                });
            }
        }

        // Subscription Selector initialization
        const initializeWidgets = () => {
            document.querySelectorAll('.subscription-widget').forEach((widget) => {
                const widgetId = widget.getAttribute('data-widget-id');
                initSubscriptionWidget(widgetId);
            });
        };

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.addedNodes.length > 0) {
                    mutation.addedNodes.forEach((node) => {
                        if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('pswp__zoom-wrap')) {
                            const subscriptionWidgets = node.querySelectorAll('.subscription-widget');
                            subscriptionWidgets.forEach((subscriptionWidget) => {
                                if (subscriptionWidget) {
                                    initializeWidgets();
                                }
                            })

                        } else if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('subscription-widget')) {
                            initializeWidgets();
                        }
                    });
                }
            });
        });

        const observeConfig = {
            childList: true,
            subtree: true
        };
        observer.observe(document.body, observeConfig);
        initializeWidgets();

        // CartDrawer Upgrade To Subscription
        if (window.location.href.includes('/cart')) {
            let subscriptionButtons = document.querySelectorAll('.subscription-button');
            subscriptionButtons.forEach(function(button) {
                if (button.getAttribute('data-click-added') === null) {
                    button.setAttribute('data-click-added', '');
                    button.addEventListener('click', function(e) {
                        e.preventDefault();
                        let optionsContainer = this.nextElementSibling;
                        let selectElement = optionsContainer.querySelector('.subscription-select');
                        optionsContainer.style.display = 'block';
                        selectElement.style.display = 'block';
                        this.style.display = 'none';
                        this.classList.add('is-loading');
                        selectElement.showPicker();
                    });
                }
            });

        let subscriptionSelects = document.querySelectorAll('.subscription-select');
        subscriptionSelects.forEach(function(select) {
            select.setAttribute('data-initial-value', select.value);

            select.addEventListener('change', function() {
            let initialValue = this.getAttribute('data-initial-value');
            if (this.value !== initialValue) {
                let cartItemID = this.closest('.upgrade-to-subscription').getAttribute('data-line-item-id');
                let selectedPlanID = this.value;
                let variantId = this.querySelector('option:checked').getAttribute('data-variant-id');
                fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: cartItemID, quantity: 0 }),
                })
                .then(response => response.json())
                .then(data => {
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                    items: [{ id: variantId, quantity: 1, selling_plan: selectedPlanID }]
                    }),
                })
                .then(response => response.json())
                .then(data => { location.reload(); })
                .catch(error => { console.error('Error adding item to cart:', error); });
                })
                .catch(error => { console.error('Error updating cart:', error); });

                this.style.display = 'none';
                this.closest('.upgrade-to-subscription').querySelector('.subscription-button').style.display = 'block';
                this.closest('.subscription-options-container').style.display = 'none';
                this.setAttribute('data-initial-value', this.value);
            }
            });
        });
        }
    // ============================================================
    // Modern Cart Upsell — Fetches cart-upsell section and injects
    // upgrade offers after matching cart items
    // ============================================================
        (function cartUpsellFeature() {
            var SECTION_ID = 'cart-upsell';
            var HOLDER_SELECTOR = '[data-cart-upsell-holder]';
            var KNOWN_LOCALES = ['en', 'de', 'fr', 'it', 'es', 'pt'];

            function getLocalePrefix() {
                var firstSegment = window.location.pathname.split('/')[1] || '';
                if (KNOWN_LOCALES.indexOf(firstSegment.toLowerCase()) !== -1) {
                return '/' + firstSegment;
                }
                return '';
            }

            function getHolder() {
                return document.querySelector(HOLDER_SELECTOR);
            }

            function refresh() {
    var holder = getHolder();

    if (!holder) {
        console.warn('[CartUpsell] refresh() — holder element not found in DOM (selector: ' + HOLDER_SELECTOR + ')');
        return;
    }

    var url = getLocalePrefix() + '/cart?section_id=' + SECTION_ID;

    console.log('[CartUpsell] fetching section →', url);

    fetch(url)
        .then(function (r) {
            console.log('[CartUpsell] response status:', r.status);
            return r.text();
        })
        .then(function (html) {
            console.log('[CartUpsell] raw section HTML:', html);

            var tmp = document.createElement('div');
            tmp.innerHTML = html;

            var debugEl = tmp.querySelector('[data-cart-upsell-debug]');

            if (debugEl) {
                try {
                    var debugData = JSON.parse(debugEl.textContent);

                    debugData.items.forEach(function (item, idx) {
                        console.log('item', idx, item);
                    });

                } catch (e) {
                    console.warn('[CartUpsell] could not parse debug JSON:', e);
                }
            }

            var section = tmp.querySelector('[data-cart-upsell-section]');
            var h = getHolder();

            if (h) {
                h.innerHTML = section ? section.innerHTML : '';

                console.log(
                    '[CartUpsell] holder updated, slide count:',
                    h.querySelectorAll('[data-cart-upsell]').length
                );

                initSliders(h);
                injectUpsellUnderItems(h);
            }
        })
        .catch(function (err) {
            console.error('[CartUpsell] refresh error:', err);
        });
}

            function handleAccept(button) {
                var card = button.closest('[data-cart-upsell]');
                if (!card) return;

                var upsellType      = (card.dataset.upsellType || '').trim().toLowerCase();
                var upsellVariantId = parseInt(card.dataset.upsellVariantId, 10);
                var sourceVariantId = parseInt(card.dataset.sourceVariantId, 10);
                var sellingPlanId = card.dataset.upsellSellingPlan;


                
                button.classList.add('is-loading');
                button.disabled = true;

                var upsellItem = { id: upsellVariantId, quantity: 1 };
                if (sellingPlanId) upsellItem.selling_plan = parseInt(sellingPlanId, 10);

                if (upsellType === 'upsell') {
                var sourceVariantId = parseInt(card.dataset.sourceVariantId, 10);
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items: [upsellItem] })
                })
                .then(function (r) {
                    if (!r.ok) throw new Error('cart/add.js failed: ' + r.status);
                    return r.json();
                })
                .then(function () {
                    return fetch('/cart.js').then(function (r) { return r.json(); });
                })
                .then(function (liveCart) {
                    var sourceItem = null;
                    for (var i = 0; i < liveCart.items.length; i++) {
                    if (liveCart.items[i].variant_id === sourceVariantId) {
                        sourceItem = liveCart.items[i];
                        break;
                    }
                    }
                    if (!sourceItem) {
                    document.dispatchEvent(new CustomEvent('updateCartDrawer'));
                    return;
                    }
                    return fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: sourceItem.key, quantity: 0 })
                    })
                    .then(function (r) {
                    if (!r.ok) return r.json().then(function (e) { throw new Error('cart/change.js failed'); });
                    return r.json();
                    })
                    .then(function () {
                    document.dispatchEvent(new CustomEvent('updateCartDrawer'));
                    });
                })
                .catch(function (err) {
                    console.error('[CartUpsell] upsell action error:', err);
                    button.classList.remove('is-loading');
                    button.disabled = false;
                });

                } else {
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items: [upsellItem] })
                })
                .then(function (r) {
                    if (!r.ok) throw new Error('cart/add.js failed: ' + r.status);
                    return r.json();
                })
                .then(function () {
                    document.dispatchEvent(new CustomEvent('updateCartDrawer'));
                })
                .catch(function (err) {
                    console.error('[CartUpsell] crosssell action error:', err);
                    button.classList.remove('is-loading');
                    button.disabled = false;
                });
                }
            }

            function injectUpsellUnderItems(holder) {
                document.querySelectorAll('[data-cart-upsell]').forEach(function(el) {
                if (!holder.contains(el)) el.remove();
                });

                var slides = Array.from(holder.querySelectorAll('[data-cart-upsell]'));
                if (slides.length === 0) return;

                slides.forEach(function(slide) {
                var sourceVariantId = slide.dataset.sourceVariantId;
                if (!sourceVariantId) return;

                var cartItem = document.querySelector('[data-items-holder] [data-item^="' + sourceVariantId + ':"]');
                if (!cartItem) {
                    cartItem = document.querySelector('[data-items-holder] [data-item="' + sourceVariantId + '"]');
                }
                if (!cartItem) return;

                slide.classList.add('is-active');
                slide.style.paddingLeft  = '20px';
                slide.style.paddingRight = '20px';
                cartItem.insertAdjacentElement('afterend', slide);
                });

                var sliderWrapper = holder.querySelector('[data-cart-upsell-slider]');
                if (sliderWrapper) sliderWrapper.style.display = 'none';
            }

            function initSliders(container) {
                container.querySelectorAll('[data-cart-upsell-slider]').forEach(function (slider) {
                slider.addEventListener('click', function (e) {
                    if (e.target.closest('[data-cart-upsell-prev]')) navigate(slider, -1);
                    else if (e.target.closest('[data-cart-upsell-next]')) navigate(slider, 1);
                });
                });
            }

            function navigate(slider, direction) {
                var slides = Array.from(slider.querySelectorAll('[data-cart-upsell]'));
                var activeIdx = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
                if (activeIdx === -1) return;
                var newIdx = (activeIdx + direction + slides.length) % slides.length;
                slides[activeIdx].classList.remove('is-active');
                slides[newIdx].classList.add('is-active');
                updateCounter(slider);
            }

            function updateCounter(slider) {
                var slides = Array.from(slider.querySelectorAll('[data-cart-upsell]'));
                var activeIdx = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
                var counter = slider.querySelector('[data-cart-upsell-counter]');
                if (counter && activeIdx !== -1) counter.textContent = (activeIdx + 1) + ' / ' + slides.length;
            }

            function handleDismiss(button) {
                var slide = button.closest('[data-cart-upsell]');
                if (!slide) return;
                var slider = slide.closest('[data-cart-upsell-slider]');
                var wasActive = slide.classList.contains('is-active');
                slide.remove();
                if (!slider) return;
                var remaining = Array.from(slider.querySelectorAll('[data-cart-upsell]'));
                if (remaining.length === 0) {
                var sectionEl = document.querySelector('[data-cart-upsell-section]');
                if (sectionEl) sectionEl.innerHTML = '';
                return;
                }
                if (remaining.length === 1) {
                var nav = slider.querySelector('[data-cart-upsell-nav]');
                if (nav) nav.remove();
                }
                if (wasActive) remaining[0].classList.add('is-active');
                updateCounter(slider);
            }

            document.addEventListener('click', function (e) {
                var acceptBtn = e.target.closest('[data-cart-upsell-accept]');
                if (acceptBtn) { handleAccept(acceptBtn); return; }

                var dismissBtn = e.target.closest('[data-cart-upsell-dismiss]');
                if (dismissBtn) { handleDismiss(dismissBtn); }
            });

            document.addEventListener('theme:cart:added', refresh);
            document.addEventListener('theme:cart:open', refresh);
            document.addEventListener('theme:cart:change', refresh);
            document.addEventListener('cart:updated', refresh);
            })();

            // ============================================================
            // Modern Cart Goals — Free Shipping & Free Gift progress bars
            // ============================================================
            (function cartGoalsFeature() {
            var SECTION_ID      = 'cart-goals';
            var HOLDER_SELECTOR = '[data-cart-goals-holder]';
            var FREE_GIFT_PROP  = '_free_gift';
            var KNOWN_LOCALES   = ['en', 'de', 'fr', 'it', 'es', 'pt'];

            var isProcessingGift = false;

            function getLocalePrefix() {
                var firstSegment = window.location.pathname.split('/')[1] || '';
                if (KNOWN_LOCALES.indexOf(firstSegment.toLowerCase()) !== -1) {
                return '/' + firstSegment;
                }
                return '';
            }

            function getHolder() {
                return document.querySelector(HOLDER_SELECTOR);
            }

            function refresh() {
                var holder = getHolder();
                if (!holder) return;

                fetch(getLocalePrefix() + '/cart?section_id=' + SECTION_ID)
                .then(function (r) { return r.text(); })
                .then(function (html) {
                    var tmp = document.createElement('div');
                    tmp.innerHTML = html;

                    var section = tmp.querySelector('[data-cart-goals-section]');
                    var h = getHolder();
                    if (h) {
                    h.innerHTML = section ? section.innerHTML : '';
                    }

                    reconcileGift();
                })
                .catch(function (err) { /* silent */ });
            }

            function reconcileGift() {
                if (isProcessingGift) return;

                var holder = getHolder();
                if (!holder) return;

                var goalsEl = holder.querySelector('[data-gift-variant-id]');
                if (!goalsEl) return;

                var giftVariantId = parseInt(goalsEl.dataset.giftVariantId, 10);
                var giftThresholdCents = parseInt(goalsEl.dataset.giftThreshold, 10);

                if (!giftVariantId || !giftThresholdCents) return;

                fetch('/cart.js')
                .then(function (r) { return r.json(); })
                .then(function (cart) {
                    var cartTotal = cart.total_price;

                    var giftLine = null;
                    for (var i = 0; i < cart.items.length; i++) {
                    var item = cart.items[i];
                    if (
                        item.variant_id === giftVariantId &&
                        item.properties &&
                        item.properties[FREE_GIFT_PROP] === 'true'
                    ) {
                        giftLine = item;
                        break;
                    }
                    }

                    if (cartTotal >= giftThresholdCents && !giftLine) {
                    addFreeGift(giftVariantId);
                    } else if (cartTotal < giftThresholdCents && giftLine) {
                    removeFreeGift(giftLine.key);
                    }
                })
                .catch(function (err) { /* silent */ });
            }

            function addFreeGift(variantId) {
                if (isProcessingGift) return;
                isProcessingGift = true;

                var props = {};
                props[FREE_GIFT_PROP] = 'true';

                fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    items: [{ id: variantId, quantity: 1, properties: props }]
                })
                })
                .then(function (r) { return r.json(); })
                .then(function () {
                    isProcessingGift = false;
                    if (window.cart && typeof window.cart.getCart === 'function') {
                    window.cart.getCart();
                    } else {
                    refresh();
                    }
                })
                .catch(function (err) {
                    isProcessingGift = false;
                });
            }

            function removeFreeGift(lineKey) {
                if (isProcessingGift) return;
                isProcessingGift = true;

                fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: lineKey, quantity: 0 })
                })
                .then(function (r) { return r.json(); })
                .then(function () {
                    isProcessingGift = false;
                    if (window.cart && typeof window.cart.getCart === 'function') {
                    window.cart.getCart();
                    } else {
                    refresh();
                    }
                })
                .catch(function (err) {
                    isProcessingGift = false;
                });
            }





            // Quantity lock/hide for a free (zeroed) line is handled server-side
            // in cart-line-items.liquid via `is_free_gift_line`, so no JS is
            // needed here to disable or hide the +/- controls.

            document.addEventListener('theme:cart:added', refresh);
            document.addEventListener('theme:cart:open', refresh);
            document.addEventListener('theme:cart:change', refresh);

            refresh();
            })();






            // ============================================================
            // Modern Cart — Spend Progress Bar (3 checkpoints)
            //
            // Fetches the `cart-progress-bar` section after every cart state
            // change and injects it into [data-cart-progress-bar-holder].
            // Only present in the DOM when settings.modern_cart_enable_progress_bar
            // is on (it replaces [data-cart-goals-holder] in that case).
            // ============================================================
            (function cartProgressBarFeature() {
            var SECTION_ID      = 'cart-progress-bar';
            var HOLDER_SELECTOR = '[data-cart-progress-bar-holder]';
            var LOG_PREFIX      = '[CartProgressBar]';
            var KNOWN_LOCALES   = ['en', 'de', 'fr', 'it', 'es', 'pt'];

            console.log(LOG_PREFIX, 'init, holder present at load:', !!document.querySelector(HOLDER_SELECTOR));

            // A bare fetch('/cart?...') always renders in the store's default
            // locale — Shopify has no other way to know which language to use
            // for an AJAX request. So we read the locale prefix off the actual
            // browser URL (window.location.pathname) and carry it over onto
            // the section-rendering request.
            function getLocalePrefix() {
                var firstSegment = window.location.pathname.split('/')[1] || '';
                if (KNOWN_LOCALES.indexOf(firstSegment.toLowerCase()) !== -1) {
                return '/' + firstSegment;
                }
                return '';
            }

            function getHolder() {
                return document.querySelector(HOLDER_SELECTOR);
            }

            function refresh() {
                var holder = getHolder();
                if (!holder) {
                console.log(LOG_PREFIX, 'refresh() skipped — no', HOLDER_SELECTOR, 'in DOM (progress bar setting probably off)');
                return;
                }

                var url = getLocalePrefix() + '/cart?section_id=' + SECTION_ID;
                console.log(LOG_PREFIX, 'refresh() fetching', url);

                fetch(url)
                .then(function (r) {
                    console.log(LOG_PREFIX, 'fetch status:', r.status, r.ok ? 'OK' : 'NOT OK');
                    return r.text();
                })
                .then(function (html) {
                    console.log(LOG_PREFIX, 'response HTML length:', html.length);

                    var tmp = document.createElement('div');
                    tmp.innerHTML = html;

                    var section = tmp.querySelector('[data-cart-progress-bar-section]');
                    console.log(LOG_PREFIX, 'section wrapper found:', !!section, section ? 'innerHTML length: ' + section.innerHTML.length : '(check that sections/cart-progress-bar.liquid renders without a Liquid error)');

                    var h = getHolder();
                    if (h) {
                    h.innerHTML = section ? section.innerHTML : '';
                    console.log(LOG_PREFIX, 'injected into holder, holder now has', h.children.length, 'child element(s)');

                    var barEl = h.querySelector('[data-cart-progress-bar]');
                    if (barEl) {
                        console.log(
                        LOG_PREFIX, 'locale debug —',
                        'request.path:', JSON.stringify(barEl.dataset.debugRequestPath),
                        'canonical_url:', JSON.stringify(barEl.dataset.debugCanonicalUrl),
                        'locale_segment:', JSON.stringify(barEl.dataset.debugLocaleSegment),
                        'discount_suffix:', JSON.stringify(barEl.dataset.debugDiscountSuffix),
                        'cp1_label:', JSON.stringify(barEl.dataset.debugCp1Label)
                        );
                    } else {
                        console.log(LOG_PREFIX, 'locale debug — [data-cart-progress-bar] not found in injected HTML (bar not showing at all?)');
                    }
                    } else {
                    console.log(LOG_PREFIX, 'holder disappeared before injection (drawer closed/re-rendered mid-fetch)');
                    }
                })
                .catch(function (err) {
                    console.warn(LOG_PREFIX, 'fetch/parse error:', err);
                });
            }

            document.addEventListener('theme:cart:added',  function () { console.log(LOG_PREFIX, 'event: theme:cart:added');  refresh(); });
            document.addEventListener('theme:cart:open',   function () { console.log(LOG_PREFIX, 'event: theme:cart:open');   refresh(); });
            document.addEventListener('theme:cart:change', function () { console.log(LOG_PREFIX, 'event: theme:cart:change'); refresh(); });

            refresh();
            })();

            (function() {
                var SAVINGS_SECTION_ID = 'cart-savings';
                var KNOWN_LOCALES = ['en', 'de', 'fr', 'it', 'es', 'pt'];

                function getLocalePrefix() {
                    var firstSegment = window.location.pathname.split('/')[1] || '';
                    if (KNOWN_LOCALES.indexOf(firstSegment.toLowerCase()) !== -1) {
                    return '/' + firstSegment;
                    }
                    return '';
                }

                function updateSavingsBanner() {
                    var holder = document.querySelector('[data-cart-savings-holder]');
                    if (!holder) return;
                    fetch(getLocalePrefix() + '/cart?section_id=' + SAVINGS_SECTION_ID)
                    .then(function(r) { return r.text(); })
                    .then(function(html) {
                        var tmp = document.createElement('div');
                        tmp.innerHTML = html;
                        var section = tmp.querySelector('[data-cart-savings-section]');
                        holder.innerHTML = section ? section.innerHTML : '';
                    })
                    .catch(function() { /* silent */ });
                }

                document.addEventListener('theme:cart:added',  updateSavingsBanner);
                document.addEventListener('theme:cart:change', updateSavingsBanner);
                document.addEventListener('theme:cart:open',   updateSavingsBanner);
                document.addEventListener('updateCartDrawer',  updateSavingsBanner);
                updateSavingsBanner();
                })();
    });




// UK market block — kept commented, not needed yet
//     document.addEventListener('DOMContentLoaded', function() {
//   const market = (document.documentElement.getAttribute('market') || '').toLowerCase();
//   const ukMarket = 'a6f1e1f5-b33d-436c-8b0c-2186ebc7a54d';
//   if (market !== ukMarket) return;

//   const productHandle = (window.location.pathname.split('/products/')[1] || '').split('?')[0].split('/')[0].toLowerCase();
//   const blockedHandles = ['nmn', 'bundle', 'longevity-bundle', 'complete-rejuvenation-routine'];
//   if (!productHandle || !blockedHandles.includes(productHandle)) return;

//   const soldOutText = window.theme?.strings?.sold_out || 'Sold Out';

//   function enforceBlock() {
//     const btn = document.querySelector('.MAINBUTTON[data-add-to-cart]');
//     if (!btn) return;
//     if (btn.disabled) return;
//     observer.disconnect();
//     btn.disabled = true;
//     const span = btn.querySelector('[data-add-to-cart-text]');
//     if (span) span.textContent = soldOutText;
//     setTimeout(() => {
//       observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
//     }, 50);
//   }

//   const observer = new MutationObserver(enforceBlock);
//   observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });

//   enforceBlock();
//   setTimeout(enforceBlock, 500);
//   setTimeout(enforceBlock, 1500);
// });

// CH market block — active

// document.addEventListener('DOMContentLoaded', function() {
//   const market = (document.documentElement.getAttribute('market') || '').toLowerCase();
//   const chMarket = 'switzerland-chf';
//   if (market !== chMarket) return;

//   const productHandle = (window.location.pathname.split('/products/')[1] || '').split('?')[0].split('/')[0].toLowerCase();
//   const blockedHandles = ['nmn', 'bundle', 'longevity-bundle', 'complete-rejuvenation-routine', 'metabolic-control-routine', 'reset-routine', 'nad-vitality-starter-kit'];
//   if (!productHandle || !blockedHandles.includes(productHandle)) return;

//   const soldOutText = window.theme?.strings?.sold_out || 'Sold Out';

//   // Block the Version C "buy once" link too (it's an <a>, not a <button>,
//   // so btn.disabled never applied to it). Capture-phase listener runs before
//   // onBuyOnceLinkClick and stops the add-to-cart from firing.
//   document.addEventListener('click', function (e) {
//     const link = e.target.closest && e.target.closest('a.subscription-widget__buy-once-link');
//     if (link) {
//       e.preventDefault();
//       e.stopImmediatePropagation();
//     }
//   }, true);

//   function enforceBuyOnceBlock() {
//     const link = document.querySelector('a.subscription-widget__buy-once-link');
//     if (!link || link.getAttribute('data-ch-blocked') === 'true') return;
//     link.setAttribute('data-ch-blocked', 'true');
//     link.setAttribute('aria-disabled', 'true');
//     link.style.pointerEvents = 'none';
//     link.style.opacity = '0.5';
//     link.style.cursor = 'not-allowed';
//     link.textContent = soldOutText;
//   }

//   function enforceBlock() {
//     const btn = document.querySelector('.MAINBUTTON[data-add-to-cart]');
//     if (!btn) return;
//     if (btn.disabled) return; // already blocked, do nothing — avoids infinite loop
//     observer.disconnect();
//     btn.disabled = true;
//     const span = btn.querySelector('[data-add-to-cart-text]');
//     if (span) span.textContent = soldOutText;
//     setTimeout(() => {
//       observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
//     }, 50);
//   }

//   const observer = new MutationObserver(enforceBlock);
//   observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });

//   enforceBlock();        enforceBuyOnceBlock();
//   setTimeout(function () { enforceBlock(); enforceBuyOnceBlock(); }, 500);
//   setTimeout(function () { enforceBlock(); enforceBuyOnceBlock(); }, 1500);
// });





    // =====================================================================
    // Welcome Kit Auto-Add
    //
    // Metafield: custom.welcome_kit_addition_to_cart (product picker, single
    // product). Set on an "original" product (e.g. an Annual or Quarterly
    // plan product whose title ends in " A" or " Q", like "Stabiliser Q").
    // When that product is in the cart, its metafield-picked "Welcome Kit"
    // product is auto-added, one Welcome Kit per unit of trigger product in
    // the cart. Welcome Kit quantity can't be edited by hand in the cart —
    // it only changes when the trigger product's quantity changes. Removing
    // all units of the trigger product removes the Welcome Kit too.
    //
    // JS alone can't read metafields (cart.js / products.js don't expose
    // them), so this relies on a tiny Liquid snippet populating
    // window.welcomeKitMap as { "<trigger_product_id>": <welcome_kit_variant_id> }
    // wherever a trigger product might be rendered (its own PDP at minimum;
    // add it to cart/upsell snippets too if triggers can be added from
    // elsewhere). See docs/welcome-kit-metafield.liquid for that snippet.
    // If the metafield is blank for a product, the snippet simply doesn't
    // emit an entry for it, and this logic does nothing for that product.
    // =====================================================================
    (function() {
        // Guard against this whole block running more than once on the same
        // page (e.g. the script tag getting included twice, or re-executed
        // by an AJAX section re-render). Two independent copies would each
        // keep their own isSyncingWelcomeKits lock/lastKnownCart, unaware of
        // each other, and could both decide "no kit line yet" at the same
        // time and both POST /cart/add.js — which Shopify won't reliably
        // merge, leaving two duplicate lines behind.
        if (window.__welcomeKitAutoAddInitialized) return;
        window.__welcomeKitAutoAddInitialized = true;

        const WELCOME_KIT_FLAG_PROPERTY = '_auto_welcome_kit';
        const WELCOME_KIT_MAP_STORAGE_KEY = 'welcomeKitMap';
        const TRIGGER_TITLE_REGEX = /\s[AQM]$/;
        const MAX_CONSECUTIVE_FAILURES = 3;
        const RECONCILE_MIN_INTERVAL_MS = 100;
        let isSyncingWelcomeKits = false;
        let pendingResync = false;
        let consecutiveFailures = 0;
        let circuitBroken = false;
        let lastReconcileAttemptAt = 0;
        let reconcileDebounceTimer = null;
        let lastKnownCart = null;

        const getWelcomeKitMap = () => {
            let stored = {};
            try {
                stored = JSON.parse(localStorage.getItem(WELCOME_KIT_MAP_STORAGE_KEY) || '{}');
            } catch (e) {
                stored = {};
            }

            if (window.welcomeKitMap) {
                // A null value means the Liquid snippet ran for this product
                // on the current page and found no metafield — evict any
                // stale mapping from a previous page load where the
                // metafield was still set, rather than merging it in.
                Object.keys(window.welcomeKitMap).forEach((productId) => {
                    const variantId = window.welcomeKitMap[productId];
                    if (variantId) {
                        stored[productId] = variantId;
                    } else {
                        delete stored[productId];
                    }
                });
                try {
                    localStorage.setItem(WELCOME_KIT_MAP_STORAGE_KEY, JSON.stringify(stored));
                } catch (e) {
                    // localStorage unavailable (private mode, quota) — fall back to in-memory only
                }
            }

            return stored;
        };

        const isTriggerLine = (item, welcomeKitMap) => {
            return Object.prototype.hasOwnProperty.call(welcomeKitMap, String(item.product_id)) &&
                TRIGGER_TITLE_REGEX.test((item.product_title || '').trim());
        };

        const isAutoWelcomeKitLine = (item) => {
            return !!(item.properties && item.properties[WELCOME_KIT_FLAG_PROPERTY] === 'true');
        };

        const getExpectedWelcomeKitQuantities = (cart, welcomeKitMap) => {
            const expected = {};

            cart.items.forEach((item) => {
                if (!isTriggerLine(item, welcomeKitMap)) return;

                const welcomeKitVariantId = String(welcomeKitMap[String(item.product_id)]);
                expected[welcomeKitVariantId] = (expected[welcomeKitVariantId] || 0) + item.quantity;
            });

            return expected;
        };

        const scheduleReconcileWelcomeKits = () => {
            if (circuitBroken) return;

            if (reconcileDebounceTimer) {
                clearTimeout(reconcileDebounceTimer);
            }

            const elapsed = Date.now() - lastReconcileAttemptAt;
            const wait = Math.max(0, RECONCILE_MIN_INTERVAL_MS - elapsed);

            reconcileDebounceTimer = setTimeout(() => {
                reconcileDebounceTimer = null;
                reconcileWelcomeKits();
            }, wait);
        };

        const reconcileWelcomeKits = () => {
            if (circuitBroken) return;

            if (isSyncingWelcomeKits) {
                pendingResync = true;
                return;
            }

            const welcomeKitMap = getWelcomeKitMap();
            // Note: deliberately no early-return when welcomeKitMap is empty.
            // An empty map doesn't mean there's nothing to do — a trigger's
            // welcome-kit metafield can be removed after a kit was already
            // added to the cart, emptying the map on the next page load, but
            // the stale flagged line still needs to be cleaned up below.

            // Claim the lock for the whole reconcile pass — including the
            // /cart.js read below — not just the eventual add/update/remove
            // call. Without this, two reconciles firing close together can
            // both read "no welcome kit line yet" before either one's add
            // has landed, and both add one, leaving quantity 2 for a moment
            // until a third pass corrects it back down to 1.
            isSyncingWelcomeKits = true;
            lastReconcileAttemptAt = Date.now();

            fetch('/cart.js')
                .then((response) => response.json())
                .then((cart) => {
                    lastKnownCart = cart;
                    const expectedQuantities = getExpectedWelcomeKitQuantities(cart, welcomeKitMap);

                    // Shopify (a script/automatic discount, outside this file)
                    // can split one logical quantity of a variant into
                    // multiple cart.items lines — e.g. pricing part of the
                    // quantity differently based on the trigger's quantity —
                    // and recalculates that split fresh on every cart read.
                    // If we correct these lines one at a time (one
                    // /cart/change.js call per line, across several reconcile
                    // passes), Shopify re-splits on the inconsistent
                    // in-between state every time, which looked like a
                    // second kit line appearing and slowly counting down.
                    // Track every line for the variant so they can all be
                    // corrected in a single atomic request instead.
                    const existingWelcomeKitLines = cart.items.filter(isAutoWelcomeKitLine);
                    const existingByVariantId = {};
                    existingWelcomeKitLines.forEach((item) => {
                        const vid = String(item.variant_id);
                        if (!existingByVariantId[vid]) {
                            existingByVariantId[vid] = { totalQuantity: 0, representativeLine: item, allLines: [] };
                        }
                        const entry = existingByVariantId[vid];
                        entry.totalQuantity += item.quantity;
                        entry.allLines.push(item);
                        // Adjust whichever line carries the largest quantity —
                        // typically the "main" line, with any discount-split
                        // remainder being the smaller one.
                        if (item.quantity > entry.representativeLine.quantity) {
                            entry.representativeLine = item;
                        }
                    });

                    const allVariantIds = new Set([
                        ...Object.keys(expectedQuantities),
                        ...Object.keys(existingByVariantId)
                    ]);

                    let nextAction = null;

                    console.debug('[WelcomeKitDebug] reconcile pass', {
                        welcomeKitMap,
                        expectedQuantities,
                        existingByVariantId
                    });

                    allVariantIds.forEach((variantId) => {
                        if (nextAction) return;

                        const expectedQuantity = expectedQuantities[variantId] || 0;
                        const existing = existingByVariantId[variantId];
                        const currentQuantity = existing ? existing.totalQuantity : 0;

                        console.debug('[WelcomeKitDebug] checking variant', variantId, { expectedQuantity, currentQuantity, existing });

                        // Correct even when the total already matches, if it's
                        // split across more than one line — consolidating
                        // down to a single line stops Shopify from having
                        // anything left to re-split on the next read.
                        if (expectedQuantity === currentQuantity && (!existing || existing.allLines.length <= 1)) return;

                        if (expectedQuantity > 0 && !existing) {
                            nextAction = () => verifyMissingThenAddWelcomeKit(variantId, expectedQuantity);
                        } else if (expectedQuantity > 0 && existing) {
                            nextAction = () => syncWelcomeKitLines(existing, expectedQuantity);
                        } else if (expectedQuantity === 0 && existing) {
                            nextAction = () => syncWelcomeKitLines(existing, 0);
                        }
                    });

                    if (nextAction) {
                        nextAction();
                    } else {
                        finishWelcomeKitSync();
                    }
                })
                .catch((error) => {
                    console.error('Error checking welcome kit eligibility:', error);
                    finishWelcomeKitSync();
                });
        };

        const finishWelcomeKitSync = () => {
            isSyncingWelcomeKits = false;

            if (circuitBroken) return;

            if (pendingResync) {
                pendingResync = false;
                scheduleReconcileWelcomeKits();
            }
        };

        const tripCircuitBreakerIfNeeded = () => {
            consecutiveFailures += 1;

            if (consecutiveFailures >= MAX_CONSECUTIVE_FAILURES) {
                circuitBroken = true;
                pendingResync = false;
                console.error(
                    `Welcome Kit sync failed ${consecutiveFailures} times in a row — stopping automatic retries for this page load ` +
                    'to avoid hammering /cart/add.js. Reload the page to try again after checking the metafield/variant setup.'
                );
            }
        };

        const parseCartResponse = (response) => {
            if (!response.ok) {
                return response.json().then(
                    (errData) => { throw new Error(errData && errData.description || `Cart request failed (${response.status})`); },
                    () => { throw new Error(`Cart request failed (${response.status}) with a non-JSON response — likely not hitting the real storefront (theme editor preview or password page)`); }
                );
            }
            return response.json();
        };

        const addWelcomeKit = (variantId, quantity) => {
            isSyncingWelcomeKits = true;

            const properties = {};
            properties[WELCOME_KIT_FLAG_PROPERTY] = 'true';

            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    items: [{ id: parseInt(variantId, 10), quantity, properties }]
                })
            })
                .then(parseCartResponse)
                .then((addedItem) => {
                    consecutiveFailures = 0;

                    // /cart/add.js only returns the added line, not the full
                    // cart — patch it into lastKnownCart so a second rapid
                    // change (before the next full reconcile fetch) sees an
                    // existing line instead of trying to add again, which
                    // would incorrectly increment quantity instead of setting it.
                    if (lastKnownCart && addedItem && addedItem.key) {
                        const existing = lastKnownCart.items.find((item) => item.key === addedItem.key);
                        if (existing) {
                            existing.quantity = addedItem.quantity;
                        } else {
                            lastKnownCart.items.push(addedItem);
                        }
                    }

                    if (window.cart && typeof window.cart.getCart === 'function') {
                        window.cart.getCart();
                    }
                    finishWelcomeKitSync();
                })
                .catch((error) => {
                    console.error('Error adding welcome kit:', error);
                    tripCircuitBreakerIfNeeded();
                    finishWelcomeKitSync();
                });
        };

        // =====================================================================
        // A single /cart.js read reporting "no kit line yet" isn't proof it's
        // really missing — Shopify's cart can briefly return stale data right
        // after a rapid mutation (e.g. the trigger's own quantity-change
        // request that's still landing server-side), so a reconcile pass can
        // read a false negative. Adding immediately on that first read is
        // what created a second, standalone kit line even though one already
        // existed. Wait a beat and re-check with a fresh read before treating
        // it as a real add — isSyncingWelcomeKits stays held the whole time
        // (set by reconcileWelcomeKits before nextAction() ran), so nothing
        // else can race in during the wait.
        // =====================================================================
        const WELCOME_KIT_ADD_VERIFY_DELAY_MS = 600;
        const verifyMissingThenAddWelcomeKit = (variantId, expectedQuantity) => {
            setTimeout(() => {
                fetch('/cart.js')
                    .then((response) => response.json())
                    .then((cart) => {
                        lastKnownCart = cart;
                        const stillMissing = !cart.items.some(
                            (item) => isAutoWelcomeKitLine(item) && String(item.variant_id) === variantId
                        );

                        if (stillMissing) {
                            addWelcomeKit(variantId, expectedQuantity);
                        } else {
                            // It exists now — let a fresh reconcile pass
                            // correct its quantity instead of adding a
                            // second line.
                            finishWelcomeKitSync();
                            scheduleReconcileWelcomeKits();
                        }
                    })
                    .catch((error) => {
                        console.error('Error re-verifying welcome kit before add:', error);
                        tripCircuitBreakerIfNeeded();
                        finishWelcomeKitSync();
                    });
            }, WELCOME_KIT_ADD_VERIFY_DELAY_MS);
        };

        // =====================================================================
        // Set the kit's total quantity for a variant in a single atomic
        // request, across every line that currently holds part of it.
        //
        // Something outside this file (a Shopify script/automatic discount)
        // can split one logical kit quantity into multiple cart.items lines
        // — e.g. pricing part of the quantity differently based on the
        // trigger's quantity — and recalculates that split fresh on every
        // cart read. Correcting lines one at a time, via separate
        // /cart/change.js requests across separate reconcile passes, means
        // Shopify sees an inconsistent in-between total after each single
        // write and re-splits on it — which showed up as a second kit line
        // appearing and slowly counting down instead of the quantity just
        // updating in place. /cart/update.js accepts a full { lineKey:
        // quantity } map and applies it as one request, so every line for
        // this variant lands on its final value together: the representative
        // line gets targetQuantity, every other line gets zeroed.
        // =====================================================================
        const syncWelcomeKitLines = (existing, targetQuantity) => {
            isSyncingWelcomeKits = true;

            const updates = {};
            existing.allLines.forEach((line) => {
                updates[line.key] = (line.key === existing.representativeLine.key) ? targetQuantity : 0;
            });

            fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ updates })
            })
                .then(parseCartResponse)
                .then((cart) => {
                    consecutiveFailures = 0;
                    lastKnownCart = cart;
                    if (window.cart && typeof window.cart.getCart === 'function') {
                        window.cart.getCart();
                    }
                    finishWelcomeKitSync();
                })
                .catch((error) => {
                    console.error('Error syncing welcome kit lines:', error);
                    tripCircuitBreakerIfNeeded();
                    finishWelcomeKitSync();
                });
        };

        const WELCOME_KIT_REMOVE_CONTROL_SELECTOR = [
            '[data-cart-remove]',
            '[data-cart-item-remove]',
            'a[href*="quantity=0"]',
            '.cart-item__remove',
            '.cart__remove',
            '.cart__item__remove',
            'a[aria-label="Remove" i]',
            'button[aria-label="Remove" i]'
        ].join(', ');

        const disableWelcomeKitCartControls = () => {
            const welcomeKitMap = getWelcomeKitMap();
            if (Object.keys(welcomeKitMap).length === 0) return;

            const welcomeKitVariantIds = new Set(Object.values(welcomeKitMap).map(String));

            welcomeKitVariantIds.forEach((variantId) => {
                const idHolder = document.querySelector(`[data-cart-item] [data-id*="${variantId}"]`);
                if (!idHolder) return;

                const cartItem = idHolder.closest('[data-cart-item]');
                if (!cartItem) return;

                // Every write below is guarded with a check first — this
                // function also runs off attribute-mutation events (see the
                // observer below, needed because some other script keeps
                // resetting these inline styles after we set them), so an
                // unconditional write would retrigger itself in a loop.

                // Remove/delete control: hidden entirely, the welcome kit
                // should only ever change quantity via the trigger product.
                // setProperty(..., 'important') so nothing else (theme CSS,
                // other scripts re-rendering the drawer) can override it.
                cartItem.querySelectorAll(WELCOME_KIT_REMOVE_CONTROL_SELECTOR).forEach((control) => {
                    if (control.style.getPropertyValue('display') !== 'none' || control.style.getPropertyPriority('display') !== 'important') {
                        control.style.setProperty('display', 'none', 'important');
                    }
                });

                // +/- buttons: hidden entirely. The number input itself
                // stays visible, showing the quantity, but locked so it
                // can't be typed into, scrolled, or nudged by arrow keys.
                cartItem.querySelectorAll('.cart__item__quantity-minus, .cart__item__quantity-plus').forEach((button) => {
                    if (button.style.getPropertyValue('display') !== 'none' || button.style.getPropertyPriority('display') !== 'important') {
                        button.style.setProperty('display', 'none', 'important');
                    }
                });

                cartItem.querySelectorAll('.cart__item__quantity input').forEach((input) => {
                    if (!input.disabled) {
                        input.disabled = true;
                        input.setAttribute('aria-disabled', 'true');
                        input.style.setProperty('pointer-events', 'none', 'important');
                    }

                    input.readOnly = true;
                    input.tabIndex = -1;

                    // Belt-and-suspenders: if some other script ever forces
                    // `disabled` back off, these listeners still block every
                    // way the value could change by hand — typing, paste,
                    // scroll-wheel over a focused number input, and the
                    // up/down arrow keys.
                    if (!input.dataset.welcomeKitLocked) {
                        input.dataset.welcomeKitLocked = 'true';
                        const blockInteraction = (event) => {
                            event.preventDefault();
                            event.stopPropagation();
                        };
                        input.addEventListener('keydown', blockInteraction);
                        input.addEventListener('wheel', blockInteraction, { passive: false });
                        input.addEventListener('paste', blockInteraction);
                        input.addEventListener('input', () => {
                            const expected = input.getAttribute('value') || '';
                            if (input.value !== expected) {
                                input.value = expected;
                            }
                        });
                    }
                });
            });
        };

        // =====================================================================
        // Sync the Welcome Kit's removal animation to the trigger's.
        //
        // Without this, removing the trigger only gets picked up by the
        // usual reconcile-after-the-fact flow: the trigger's row slides out
        // immediately (the theme's own removal animation), but the Welcome
        // Kit row just sits there until a full read-cart + remove-cart round
        // trip completes, then vanishes abruptly with no animation.
        //
        // Instead, the instant the trigger's remove control is clicked, find
        // the matching Welcome Kit row and .click() its own (hidden) remove
        // control too — that runs the theme's real removal flow, including
        // its animation, on both rows in lockstep with zero added latency.
        // The dataset flag stops this same listener from reacting to that
        // synthetic click and recursing.
        // =====================================================================
        const getTriggerVariantToWelcomeKitVariantMap = () => {
            const welcomeKitMap = getWelcomeKitMap();
            const map = {};

            if (!lastKnownCart || Object.keys(welcomeKitMap).length === 0) return map;

            lastKnownCart.items.forEach((item) => {
                if (!isTriggerLine(item, welcomeKitMap)) return;
                map[String(item.variant_id)] = String(welcomeKitMap[String(item.product_id)]);
            });

            return map;
        };

        document.addEventListener('click', (event) => {
            const removeControl = event.target.closest(WELCOME_KIT_REMOVE_CONTROL_SELECTOR);
            if (!removeControl || removeControl.dataset.welcomeKitSyncedRemove) return;

            const cartItem = removeControl.closest('[data-cart-item]');
            if (!cartItem) return;

            const idHolder = cartItem.querySelector('[data-id]');
            const clickedVariantId = idHolder ? String(idHolder.dataset.id || '').split(':')[0] : '';
            if (!clickedVariantId) return;

            const welcomeKitVariantId = getTriggerVariantToWelcomeKitVariantMap()[clickedVariantId];
            if (!welcomeKitVariantId || !lastKnownCart) return;

            // Two different trigger products can share the same Welcome
            // Kit. If another trigger line still needs it after this one's
            // removed, only the quantity should change — sliding the whole
            // row out (and the theme re-adding it a moment later once
            // reconcile notices it's still needed) would be visibly wrong.
            // Zero out the clicked line in the cached snapshot and recompute
            // before deciding which path to take.
            const welcomeKitMap = getWelcomeKitMap();
            const remainingQuantities = getExpectedWelcomeKitQuantities(
                {
                    items: lastKnownCart.items.map((item) =>
                        String(item.variant_id) === clickedVariantId ? { ...item, quantity: 0 } : item
                    )
                },
                welcomeKitMap
            );
            const remainingForThisKit = remainingQuantities[welcomeKitVariantId] || 0;

            const welcomeKitIdHolder = document.querySelector(`[data-cart-item] [data-id*="${welcomeKitVariantId}"]`);
            const welcomeKitItem = welcomeKitIdHolder && welcomeKitIdHolder.closest('[data-cart-item]');
            if (!welcomeKitItem) return;

            if (remainingForThisKit > 0) {
                // Other trigger(s) still need this Welcome Kit — just paint
                // the reduced quantity instantly (display only, no network
                // call) and let the debounced reconcile persist the real
                // update once the trigger's own removal request has
                // actually landed server-side. Firing our own
                // /cart/change.js write here, at the same instant the
                // theme's own removal request goes out, raced it: two
                // concurrent writes to the same cart could make a
                // subsequent /cart.js read see a transient phantom
                // duplicate line for the Welcome Kit. Waiting for the
                // trigger's write to finish first (reconcile only runs off
                // the resulting cart:updated/theme:cart:change event)
                // avoids that race entirely.
                const changedItem = lastKnownCart.items.find((item) => String(item.variant_id) === clickedVariantId);
                if (changedItem) changedItem.quantity = 0;
                paintWelcomeKitQuantity(welcomeKitVariantId, remainingForThisKit);
                return;
            }

            const welcomeKitRemoveControl = welcomeKitItem.querySelector(WELCOME_KIT_REMOVE_CONTROL_SELECTOR);
            if (welcomeKitRemoveControl && welcomeKitRemoveControl !== removeControl) {
                welcomeKitRemoveControl.dataset.welcomeKitSyncedRemove = 'true';
                welcomeKitRemoveControl.click();
            }
        }, true);

        // =====================================================================
        // Paint the Welcome Kit's quantity change optimistically.
        //
        // The trigger's own +/- buttons update its number instantly (that's
        // the theme's native behavior), but the Welcome Kit's number only
        // used to update after the full reconcile round trip (read cart,
        // then write the new quantity) landed — a visible lag between the
        // two numbers changing. Instead, the moment the trigger's quantity
        // input reports a new value, patch our cached cart snapshot and
        // paint the Welcome Kit's input to the recalculated total right
        // away. scheduleReconcileWelcomeKits() still runs straight after to
        // persist the real change — since the number's already right, that
        // round trip lands invisibly instead of being what the user waits on.
        // =====================================================================
        const paintWelcomeKitQuantity = (welcomeKitVariantId, quantity) => {
            const idHolder = document.querySelector(`[data-cart-item] [data-id*="${welcomeKitVariantId}"]`);
            const welcomeKitItem = idHolder && idHolder.closest('[data-cart-item]');
            if (!welcomeKitItem) return;

            welcomeKitItem.querySelectorAll('.cart__item__quantity input').forEach((input) => {
                input.value = quantity;
                input.setAttribute('value', String(quantity));
            });
        };

        const handleTriggerQuantityInputEvent = (event) => {
            const input = event.target.closest('.cart__item__quantity input');
            if (!input || input.dataset.welcomeKitLocked) return;

            const cartItem = input.closest('[data-cart-item]');
            if (!cartItem) return;

            const idHolder = cartItem.querySelector('[data-id]');
            const changedVariantId = idHolder ? String(idHolder.dataset.id || '').split(':')[0] : '';
            if (!changedVariantId) return;

            const welcomeKitVariantId = getTriggerVariantToWelcomeKitVariantMap()[changedVariantId];
            if (!welcomeKitVariantId || !lastKnownCart) return;

            const newQuantity = parseInt(input.value, 10);
            if (!Number.isFinite(newQuantity) || newQuantity < 0) return;

            const changedItem = lastKnownCart.items.find((item) => String(item.variant_id) === changedVariantId);
            if (!changedItem || changedItem.quantity === newQuantity) return;

            // Patch the cached snapshot optimistically so the recalculation
            // below (and the reconcile pass right after) both see the new
            // total immediately, without waiting on a fresh /cart.js read.
            changedItem.quantity = newQuantity;

            // Paint the number only — no network call here. Firing our own
            // /cart/change.js write for the kit at this exact instant would
            // race the theme's own upcoming /cart/change.js write for the
            // trigger (both writes hit the same cart at once), which can
            // make Shopify briefly show a duplicate kit line on the next
            // /cart.js read. scheduleReconcileWelcomeKits() below only
            // actually fires once the trigger's own request completes and
            // dispatches cart:updated/theme:cart:change, so by the time it
            // runs, there's no concurrent write to race.
            const welcomeKitMap = getWelcomeKitMap();
            const expectedQuantities = getExpectedWelcomeKitQuantities(lastKnownCart, welcomeKitMap);
            paintWelcomeKitQuantity(welcomeKitVariantId, expectedQuantities[welcomeKitVariantId] || 0);
        };

        document.addEventListener('change', handleTriggerQuantityInputEvent, true);
        document.addEventListener('input', handleTriggerQuantityInputEvent, true);

        const cartEventsToReconcile = ['theme:cart:open', 'theme:cart:added', 'theme:cart:change', 'cart:updated'];
        cartEventsToReconcile.forEach((eventName) => {
            document.addEventListener(eventName, () => {
                scheduleReconcileWelcomeKits();
                disableWelcomeKitCartControls();
                setTimeout(disableWelcomeKitCartControls, 50);
            });
        });

        const welcomeKitItemsObserver = new MutationObserver((mutations) => {
            const hasAddedNodes = mutations.some((mutation) => mutation.addedNodes.length > 0);
            if (hasAddedNodes) {
                disableWelcomeKitCartControls();
            }
        });

        const welcomeKitItemsHolder = document.querySelector('[data-items-holder]');
        if (welcomeKitItemsHolder) {
            welcomeKitItemsObserver.observe(welcomeKitItemsHolder, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['style', 'class', 'disabled']
            });
        }

        reconcileWelcomeKits();
        disableWelcomeKitCartControls();
        setTimeout(disableWelcomeKitCartControls, 50);
    })();

    // ^^ Keep your scripts inside this IIFE function call to
    // avoid leaking your variables into the global scope.
})();
